import React from 'react';
import ConfirmDialog from './ConfirmDialog.jsx';
import moment from 'moment';
import { connect } from 'react-redux';
import classNames from 'classnames/bind';
import { Dialog } from "@blueprintjs/core";
import { DropDown } from 'components/tt-forms/common';
import { ShowIf, ShowIfCheck } from 'components/utils';
import {
  DropDownChonPhongBanThuocCoQuan,
  DropDownChonCanBoGiaiQuyet,
  DropDownChonKetLuanNoiDungKhieuNai,
  DropDownKetQuaGiaiQuyetDon,
  DropDownChonCoQuanDieuTra,
  DropDownMulipleUse,
  DropDownNguoiKy,
  DropDownChonKetQuaGiaiQuyet
} from 'components/tt-forms';
import { TextArea, DatePicker, Input, InputNumber, Text, TextMessage } from 'components/tt-forms/common';
import { GiaiQuyetDonThu, DuLieuHeThong } from 'api';
import { Link } from 'react-router';
import { ContainerFileDinhKem} from 'components/upload';
import {
  getParams
} from 'modules/giai-quyet-don/subView/GetParams.jsx';
import {checkThamSo} from "constants/checkThamSo";
import {BlockBaoCaoKQTTXM} from 'modules/giai-quyet-don/subView';
const vaiTro = 'CHUYEN_VIEN';
const loaiTepDinhKem = 'QUYET_DINH';
const loaiQuyTrinh = 'GIAI_QUYET_DON';

class TruongPhongNhanBaoCaoTTXMDonKhieuNai extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      open: false,
      onSave: false,
      validate: false,
      id: this.props.id,
      role: this.props.roleGQ,
      loaiDon: this.props.loaiDon,
      gqText: (this.props.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH') ? 'Ban hành văn bản giải quyết' : ((this.props.loaiDon == 'DON_TO_CAO') ? 'Ban hành kết luận nội dung tố cáo' : 'Ban hành quyết định giải quyết'),
      openDialogLuuHoSo: false,
      openDialogGiaoDoiThoai: false,
      btnLoading: false,
      btnSaveLoading: false,
      focused: false,
      openDialogTruongPhongGiaiQuyetDon: false,
      openDialogTruongPhongTTXM: false,
      openDialogNoiChinh: false,
      openDialogVanPhong: false,
      openDialogGiaoTTXML: false,
      yKienGiaiQuyet: '',
      canBoGiaiQuyet: '',
      ngayHetHanGiaiQuyet: '',
      ngayHetHanKTDX: '',
      phongBanGiaiQuyet: '',
      taiLieuVanThu: [],
      taiLieuVanThuUpdate: [],
      taiLieuVanThuDelete: [],
      dataGiaiQuyetDon: [],
      dataFileDinhKem: {
        quyetDinhGiaiQuyet: [],
        giaoCoQuanDieuTra: [],
        giaHan: [],
        data: []
      },

      dataNextStates: [],
      dataTaiLieuVanThuDelete: [],
      thongTinGiaiQuyetDonId: this.props.thongTinGiaiQuyetDonId,
      coQuanQuanLyId: this.props.coQuanQuanLyId,
      coQuanQuanLyNguoiDung: this.props.coQuanQuanLyNguoiDung,
      nextState: '',
      ketQuaXLDGiaiQuyetInit: '',
      listTaiLieuVanThuGiaiQuyetDon: [],
      listTaiLieuVanThuGiaiQuyetDonView: [],
      dataPhongBan: [],

      giaoCoQuanDieuTra: false,
      theoDoiThucHien: false,
      khoiTo: false,
      showTienDoGiaiQuyet: false,

      ketQuaXLDGiaiQuyet: '',

      donViThamTraXacMinh: '',
      ngayHetHanTTXM: '',

      taiLieuVanThuGiaoCoQuanDieuTra: [],

      coQuanDieuTra: '',
      soVuGiaoCoQuanDieuTra: '',
      soDoiTuongGiaoCoQuanDieuTra: '',

      tienPhaiThuNhaNuoc: '',
      datPhaiThuNhaNuoc: '',
      tienPhaiTraCongDan: '',
      datPhaiTraCongDan: '',

      tongSoNguoiXuLyHanhChinh: '',
      soNguoiDaBiXuLyHanhChinh: '',

      hinhThucTheoDoi: '',
      coQuanTheoDoi: '',
      ketQuaThucHienTheoDoi: '',

      soVuBiKhoiTo: '',
      soDoiTuongBiKhoiTo: '',

      tienDaThuNhaNuoc: '',
      datDaThuNhaNuoc: '',
      tienDaTraCongDan: '',
      datDaTraCongDan: '',

      soVuGiaiQuyetKhieuNai: '',

      soLanGiaiQuyetLai: '',
      ketQuaGiaiQuyetLan2: '',
      noiDungKetLuanGiaiQuyetLai: '',

      ketQuaGiaiQuyetKhac: '',
      ketQuaThucHienKhac: '',

      allowAttach: false,
      allowAttachGiaoCoQuanDieuTra: false,
      checkDonViPhongBanKhac: false,
      phoPhong: false,

      doiThoai: false,
      thoiGianDoiThoai: '',
      diaDiemDoiThoai: '',
      tienDoDoiThoai: '',

      dataDonViTheoDoi: [],
      dataKetQuaGiaiQuyetDon: [],
      dataCoQuanTheoDoi: [],
      soVanBan: '',
      ngayBanHanh: '',
      nguoiBanHanh: '',
      setHuongGiaiQuyet: false,
      typeButton: '',
      donViTheoDoiThucHien: '',
      dataDonViNhanTDTH: [],
      nextStateInit: '',
      message: 'Chọn "'+ this.gqText +'" sẽ kết thúc quá trình giải quyết đơn và bạn không thao tác được với trường tiến độ giải quyết nữa. Bạn có đồng ý?',
      ngayHetHanGiaiQuyetTTXMLai: '',
      ngayHetHanTTXMLai: '',
      noiDungGiaoTTXMLai: '',
      lyDoBanHanhQuyetDinhDinhChi: '',
      lyDoBanHanhQuyetDinhGiaiQuyet: '',
      ngayRaThongBaoTTXM: '',
      loaiVanBanSuggest: '',
      ngayQuyetDinhSuggest: '',
      valueSelectBox: '',
      dataSelectBox : [
        {
          "giaTri" : "TU_GIAI_QUYET",
          "ten" : "Tự giải quyết"
        }, {
          "giaTri" : "CHUYEN_PHONG_BAN_KHAC",
          "ten" : "Chuyển phòng ban khác"
        }
      ],
    }
  }

  componentDidMount() {
    this.getThongTinGiaiQuyetDon(this.state.thongTinGiaiQuyetDonId);
    this.getPhongBanThuocCoQuan();
    this.getCoQuanTheoDoiEnumn();
    this.getDonViNhanTDTH();
    this.getListDonViNhanTDTH();
    this.getKetQuaGiaiQuyetDon();
    this.getThoiHanGQDonMacDinh();
    this.getThoiHanTTXMMacDinh();
    if(this.props.nhanDuThao == true) {
      this.setState({
        nextState: 'TRUONG_PHONG_GIAO_VIEC_CAN_BO_SAU_KHI_NHAN_DU_THAO'
      })
    }

    if(this.props.dataNextStates) {
      let data = [...this.props.dataNextStates];
      data = data.filter(props => {
        return props.type != 'CAN_BO_GIAO_DON_VI_TTXM_LAP_DU_THAO' &&
          props.type != 'CAN_BO_GUI_YEU_CAU_THEO_DOI_THUC_HIEN' &&
          props.type != 'CAN_BO_GIAO_TTXM_LAI'
      });
      /* if (checkThamSo() == 'CQQL_PHONG_NOI_CHINH') {
        data = data.filter(props => {
          return props.type != 'TRUONG_PHONG_NHAN_KET_QUA_TTXM'
        });
      } */
      if (checkThamSo() === 'CQQL_BAN_TIEP_CONG_DAN' && this.props.roleGQ === "truongPhongBanTiepCongDan") {
        data = data.filter(props => props.type !== "TRUONG_PHONG_GIAO_VIEC_CAN_BO_SAU_KHI_NHAN_KET_QUA_TTXM");
      } else {
        let getPhongBan = data.find(item => item.type === "NHANKQDUTHAO_GIAO_PHONG_CUNG_CAP" || item.type === "TRUONG_PHONG_NHAN_KET_QUA_TTXM");
        if (getPhongBan) {
          let phoPhong = {
            stateId : getPhongBan.stateId,
            ten: "Trưởng phòng giao việc phó phòng",
            tenVietTat: "Giao việc phó phòng",
            type: "TRUONG_PHONG_GIAO_VIEC_PHO_PHONG"
          }
          data.push(phoPhong);
        }
      }
      data.map(item => {
        if (item.type == 'KET_THUC') {
          item.tenVietTat = 'Tự giải quyết';
          item.ten = 'Trưởng phòng tự giải quyết';
        }
      })
      this.setState({
        dataNextStates: data
      });
    }

    if (window.debug) {
      console.log('giai-quyet-don/subView/TruongPhongNhanBaoCaoTTXMDonKhieuNai');
    }
  }

  getThoiHanGQDonMacDinh() {
    DuLieuHeThong.actions.getThoiHanGQDonMacDinh.request(null, {type: this.props.loaiDon}).then(res => {
      let thoiHanXuLyMacDinh = new Date(res.data);
      this.setState({
        ngayHetHanGiaiQuyetTTXMLai: thoiHanXuLyMacDinh
      })
    })
  }

  getThoiHanTTXMMacDinh() {
    let params = {
      type: this.props.loaiDon
    }
    if ((this.props.loaiDon == 'DON_KHIEU_NAI' || this.props.loaiDon == 'DON_TO_CAO') && this.state.ngayRaThongBaoTTXM && this.state.tienDoDoiThoai == 'GIAO_THAM_TRA_XAC_MINH_LAI') {
      params.ngayRaThongBaoTTXM = moment(this.state.ngayRaThongBaoTTXM, 'DD/MM/YYYY').add(7, 'hours').toISOString();
    }
    DuLieuHeThong.actions.getThoiHanTTXMMacDinh.request(null, params).then(res => {
      let thoiHanXuLyMacDinh = new Date(res.data);
      this.setState({
        ngayHetHanTTXMLai: thoiHanXuLyMacDinh
      })
    })
  }

  getDonViNhanTDTH() {
    let params = {
      donId: Number(this.state.id),
      loaiDon: this.state.loaiDon
    }
    GiaiQuyetDonThu.actions.getDonViNhanTDTH.request('', params).then(res => {
      if(res.data) {
        this.setState({
          donViTheoDoiThucHien: res.data.coQuanQuanLyId,
          tenDonViTheoDoiThucHien: res.data.ten
        })
      }
    })
  }

  getListDonViNhanTDTH() {
    GiaiQuyetDonThu.actions.getListDonViNhanTDTH.request().then(res => {
      if(res.data._embedded) {
        this.setState({
          dataDonViNhanTDTH: res.data._embedded.coQuanQuanLies
        })
      }
    })
  }

  getCoQuanTheoDoiEnumn() {
    GiaiQuyetDonThu.actions.getCoQuanTheoDoiEnumn.request().then(res => {
      if (res.data) {
        this.setState({
          dataCoQuanTheoDoi: res.data
        })
      }
    })
  }

  componentDidUpdate(prevProps, prevState) {
    if(prevProps.truongPhongThuHoi == true) {
      if (this.select && prevState.focused == false) {
        this.setState({
          focused: true
        })
        this.select.focus();
      }
    }
    /* if (this.state.checkDonViPhongBanKhac == true) {
      let dataOption = this.state.dataNextStates;
      let indexOption = dataOption.findIndex(x => x.type == 'TRUONG_PHONG_NHAN_KET_QUA_TTXM')
      if (indexOption != -1 && this.state.dataPhongBan.length == 0) {
        let newOption = [...this.state.dataNextStates];
        newOption.splice(indexOption, 1);
        this.state.dataNextStates = newOption;
        this.setState({
          ...this.state
        })
      }
     } */
    this.checkHuongGiaiQuyet();
  }

  getKetQuaGiaiQuyetDon() {
    let params = {
      banHanhQuyetDinh: true,
      khongCoDoiThoai: false,
      loaiDon: this.props.loaiDon
    }
    GiaiQuyetDonThu.actions.getKetQuaGiaiQuyetDon.request(params).then(res => {
      if (res.data) {
        this.setState({
          dataKetQuaGiaiQuyetDon: res.data
        })
      }
    })
  }

  getPhongBanThuocCoQuan() {
    GiaiQuyetDonThu.actions.getPhongBanThuocCoQuan.request().then(res => {
      if(res.data._embedded) {
        this.state.checkDonViPhongBanKhac = true;
        this.state.dataPhongBan = res.data._embedded.coQuanQuanLies;
        this.setState({
          ...this.state
        })
      } else {
        this.state.checkDonViPhongBanKhac = true;
        this.setState({
          ...this.state
        })
      }
    })
  }

  handleCheck(name, e) {
    this.setState({
      [name]: e
    })
    if (name =='giaoCoQuanDieuTra') {
      this.checkFileCoQuanDieuTra();
    }
    if (!e) {

    }
    this.props.handleChangeData();
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.dataNextStates) {
      let data = [...nextProps.dataNextStates];
      data = data.filter(props => {
        return props.type != 'CAN_BO_GIAO_DON_VI_TTXM_LAP_DU_THAO' &&
          props.type != 'CAN_BO_GUI_YEU_CAU_THEO_DOI_THUC_HIEN' &&
          props.type != 'CAN_BO_GIAO_TTXM_LAI'
      });
      /* if (checkThamSo() == 'CQQL_PHONG_NOI_CHINH') {
        data = data.filter(props => {
          return props.type != 'TRUONG_PHONG_NHAN_KET_QUA_TTXM'
        });
      } */
      if (checkThamSo() === 'CQQL_BAN_TIEP_CONG_DAN' && this.props.roleGQ === "truongPhongBanTiepCongDan") {
        data = data.filter(props => props.type !== "TRUONG_PHONG_GIAO_VIEC_CAN_BO_SAU_KHI_NHAN_KET_QUA_TTXM");
      } else {
        let getPhongBan = data.find(item => item.type === "NHANKQDUTHAO_GIAO_PHONG_CUNG_CAP" || item.type === "TRUONG_PHONG_NHAN_KET_QUA_TTXM");
        if (getPhongBan) {
          let phoPhong = {
            stateId : getPhongBan.stateId,
            ten: "Trưởng phòng giao việc phó phòng",
            tenVietTat: "Giao việc phó phòng",
            type: "TRUONG_PHONG_GIAO_VIEC_PHO_PHONG"
          }
          data.push(phoPhong);
        }
      }
      data.map(item => {
        if (item.type == 'KET_THUC') {
          item.tenVietTat = 'Tự giải quyết';
          item.ten = 'Trưởng phòng tự giải quyết';
        }
      })
      this.setState({
        dataNextStates: data
      });
    }
  }

  componentWillUnmount() {

  }

  resetData(type) {
    if (type == 'nextState') {
      this.setState({
        ketQuaXLDGiaiQuyet: '',
        tienDoDoiThoai: ''
      })
    }
    this.setState({
      canBoGiaiQuyet: '',
      thoiGianDoiThoai:'',
      diaDiemDoiThoai:'',

      coQuanDieuTra:'',
      soVuGiaoCoQuanDieuTra: 0,
      soDoiTuongGiaoCoQuanDieuTra: 0,

      tienPhaiThuNhaNuoc: 0,
      datPhaiThuNhaNuoc: 0,
      tienPhaiTraCongDan: 0,
      datPhaiTraCongDan: 0,
      tongSoNguoiXuLyHanhChinh: 0,
      soNguoiDaBiXuLyHanhChinh: 0,

      hinhThucTheoDoi:'',
      coQuanTheoDoi:'',
      ketQuaThucHienTheoDoi:'',

      khoiTo:false,
      soVuBiKhoiTo: 0,
      soDoiTuongBiKhoiTo: 0,

      soVanBan: '',
      ngayBanHanh: '',
      nguoiBanHanh: '',

      tienDaThuNhaNuoc: 0,
      datDaThuNhaNuoc: 0,
      tienDaTraCongDan: 0,
      datDaTraCongDan: 0,

      giaoCoQuanDieuTra:false,
      quyetDinhGiaiQuyetKhieuNai:false,
      theoDoiThucHien:false,

      tienPhaiThuNhaNuocQDGQ: 0,
      tienPhaiTraCongDanQDGQ: 0,
      datPhaiThuNhaNuocQDGQ: 0,
      datPhaiTraCongDanQDGQ: 0,
      soNguoiDuocTraLaiQuyenLoi: 0,

      soVuGiaiQuyetKhieuNai: 0,

      soLanGiaiQuyetLai: 0,
      ketQuaGiaiQuyetLan2:'',
      noiDungKetLuanGiaiQuyetLai:'',

      ketQuaGiaiQuyetKhac:'',
      ketQuaThucHienKhac:'',
      noiDungDoiThoai:'',
      noiDungGiaoLapDuThao:'',

      yKienGiaiQuyet: '',
      allowAttach: false
    }, ()=> {
      this.renderAttachFile();
      this.getNgayHetHanLapDuThao();
    })

  }

  onChange(name, e) {
    if (name == 'ketQuaXLDGiaiQuyet' && e.target.value == 'DA_CO_QUYET_DINH_GIAI_QUYET') {
      this.state.message = `Chọn "${this.state.gqText}" sẽ kết thúc quá trình giải quyết đơn và bạn không thao tác được với trường tiến độ giải quyết nữa. Bạn có đồng ý?`;
      this.state.open = true;
      this.state.allowAttach = false;
      this.state.valueKetQua = e.target.value;

      this.setState({
        ...this.state
      })
      this.resetData();
    } else if (name == 'ketQuaXLDGiaiQuyet' && e.target.value == 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI') {
      this.state.message = 'Chọn "Ban hành quyết định đình chỉ" sẽ kết thúc quá trình giải quyết đơn và bạn không thao tác được với trường tiến độ giải quyết nữa. Bạn có đồng ý?';
      this.state.open = true;
      this.state.allowAttach = false;
      this.state.valueKetQua = e.target.value;

      this.setState({
        ...this.state
      })
      this.resetData();
    } else {
      this.state[name] = e.target.value;
      this.state.valueKetQua = '';
      this.setState({
        ...this.state
      });

      if(name == 'ketQuaXLDGiaiQuyet') {
        this.resetData();
      }

      if(name =='tienDoDoiThoai' && e.target.value != 'KHONG_DOI_THOAI') {
        this.state.ketQuaXLDGiaiQuyet = '';
        this.setState({
          ...this.state
        });
        this.resetData();
      }

      if (name === 'tienDoDoiThoai' && e.target.value === 'KHONG_DOI_THOAI') {
        this.resetData();
      }

      if (name =='tienDoDoiThoai' || name == 'ketQuaXLDGiaiQuyet' || name == 'nextState' || name == 'hinhThucTheoDoi' || name == 'soLanGiaiQuyetLai' || name == 'ketQuaGiaiQuyetLan2') {

      }

      if (name == 'soLanGiaiQuyetLai' && Number(e.target.value) <= 1) {
        this.setState({
          ketQuaGiaiQuyetLan2: ''
        })
      }

      if (name == 'ketQuaGiaiQuyetLan2' && Number(e.target.value) != 'HUY_SUA_QDGQ_LAN_I') {
        this.setState({
          noiDungKetLuanGiaiQuyetLai: ''
        })
      }
    }

    if (name === 'valueSelectBox' && e.target.value === 'TU_GIAI_QUYET') {
      this.setState({
        nextState: "KET_THUC"
      });
    }
    if (name === 'valueSelectBox' && e.target.value === 'CHUYEN_PHONG_BAN_KHAC') {
      this.setState({
        nextState: "TRUONG_PHONG_NHAN_KET_QUA_TTXM",
      });
      this.resetData();
    }
    if (name === 'nextState') {
      this.resetData('nextState');
    }

    if (name === 'valueSelectBox' && e.target.value === "CHUYEN_PHONG_BAN_KHAC") {
      let chuyenPhongBanKhac = this.state.dataNextStates.find(state => state.type === "TRUONG_PHONG_NHAN_KET_QUA_TTXM")
      let tempState = '';
      if (chuyenPhongBanKhac) {
        tempState = "TRUONG_PHONG_NHAN_KET_QUA_TTXM";
      } else {
        tempState = "NHANKQDUTHAO_GIAO_PHONG_CUNG_CAP";
      }
      this.setState({
        nextState: tempState
      });
      this.resetData('nextState');
    }

    if (name === 'valueSelectBox' && e.target.value === "TU_GIAI_QUYET") {
      this.setState({
        nextState: "KET_THUC"
      });
      this.resetData();
    }

    this.props.handleChangeData();
  }

  getThongTinGiaiQuyetDon(id) {
    if(typeof this.state.thongTinGiaiQuyetDonId != 'undefined') {
      let params = {
        id: id
      };
      GiaiQuyetDonThu.actions.getThongTinGiaiQuyetDon.request(params).then(res => {
        if(res.data) {
          this.setState({
            dataGiaiQuyetDon: res.data,
            canBoGiaiQuyet: res.data.canBoGiaiQuyetInfo ? res.data.canBoGiaiQuyetInfo.congChucId : '',
            phongBanGiaiQuyet: res.data.phongBanGiaiQuyetInfo ? res.data.phongBanGiaiQuyetInfo.coQuanQuanLyId : '',
            yKienGiaiQuyet: res.data.yKienGiaiQuyet ? res.data.yKienGiaiQuyet : '',
            ngayHetHanGiaiQuyet: res.data.ngayHetHanGiaiQuyet ? new Date(res.data.ngayHetHanGiaiQuyet) : '',
            ngayHetHanKTDX: res.data.ngayHetHanKTDX ? new Date(res.data.ngayHetHanKTDX): '',
            phoPhong: res.data.phoPhong,

            ketLuanNoiDungKhieuNai: res.data.ketLuanNoiDungKhieuNai ? res.data.ketLuanNoiDungKhieuNai : (res.data.ketLuanNoiDungKhieuNaiGiaoTTXM || ''),

            doiThoai: res.data.doiThoai,
            thoiGianDoiThoai: res.data.thoiGianDoiThoai ? new Date(res.data.thoiGianDoiThoai) : '',
            diaDiemDoiThoai: res.data.diaDiemDoiThoai,

            coQuanDieuTra: res.data.coQuanDieuTraInfo ? res.data.coQuanDieuTraInfo.coQuanQuanLyId : '',
            soVuGiaoCoQuanDieuTra: res.data.soVuGiaoCoQuanDieuTra ? res.data.soVuGiaoCoQuanDieuTra : 0,
            soDoiTuongGiaoCoQuanDieuTra: res.data.soDoiTuongGiaoCoQuanDieuTra ? res.data.soDoiTuongGiaoCoQuanDieuTra : 0,

            soVanBan: res.data.soVanBan ? res.data.soVanBan : '',
            ngayBanHanh: res.data.ngayBanHanh ? new Date(res.data.ngayBanHanh) : '',
            nguoiBanHanh: res.data.nguoiBanHanhInfo ? res.data.nguoiBanHanhInfo.congChucId : '',

            tienPhaiThuNhaNuoc: res.data.tienPhaiThuNhaNuoc ? res.data.tienPhaiThuNhaNuoc : 0,
            datPhaiThuNhaNuoc: res.data.datPhaiThuNhaNuoc ? res.data.datPhaiThuNhaNuoc : 0,
            tienPhaiTraCongDan: res.data.tienPhaiTraCongDan ? res.data.tienPhaiTraCongDan : 0,
            datPhaiTraCongDan: res.data.datPhaiTraCongDan ? res.data.datPhaiTraCongDan : 0,
            tongSoNguoiXuLyHanhChinh: res.data.tongSoNguoiXuLyHanhChinh ? res.data.tongSoNguoiXuLyHanhChinh : 0,
            soNguoiDaBiXuLyHanhChinh: res.data.soNguoiDaBiXuLyHanhChinh ? res.data.soNguoiDaBiXuLyHanhChinh : 0,

            hinhThucTheoDoi: res.data.hinhThucTheoDoi ? res.data.hinhThucTheoDoi : '',
            coQuanTheoDoi: res.data.coQuanTheoDoi ? res.data.coQuanTheoDoi : '',
            ketQuaThucHienTheoDoi: res.data.ketQuaThucHienTheoDoi ? res.data.ketQuaThucHienTheoDoi : '',

            khoiTo: res.data.khoiTo,
            soVuBiKhoiTo: res.data.soVuBiKhoiTo ? res.data.soVuBiKhoiTo : 0,
            soDoiTuongBiKhoiTo: res.data.soDoiTuongBiKhoiTo ? res.data.soDoiTuongBiKhoiTo : 0,

            tienDaThuNhaNuoc: res.data.tienDaThuNhaNuoc ? res.data.tienDaThuNhaNuoc : 0,
            datDaThuNhaNuoc: res.data.datDaThuNhaNuoc ? res.data.datDaThuNhaNuoc : 0,
            tienDaTraCongDan: res.data.tienDaTraCongDan ? res.data.tienDaTraCongDan : 0,
            datDaTraCongDan: res.data.datDaTraCongDan ? res.data.datDaTraCongDan : 0,

            giaoCoQuanDieuTra: res.data.giaoCoQuanDieuTra,
            quyetDinhGiaiQuyetKhieuNai: res.data.quyetDinhGiaiQuyetKhieuNai,
            theoDoiThucHien: res.data.theoDoiThucHien,

            nextState: res.data.phoPhong ? "TRUONG_PHONG_GIAO_VIEC_PHO_PHONG" : (res.data.nextStateInfo ? res.data.nextStateInfo.type : (this.props.truongPhongThuHoi == true ? 'KET_THUC' : '')),
            nextStateInit: res.data.nextStateInfo ? res.data.nextStateInfo.type : '',

            tienPhaiThuNhaNuocQDGQ: res.data.tienPhaiThuNhaNuocQDGQ ? res.data.tienPhaiThuNhaNuocQDGQ : 0,
            tienPhaiTraCongDanQDGQ: res.data.tienPhaiTraCongDanQDGQ ? res.data.tienPhaiTraCongDanQDGQ : 0,
            datPhaiThuNhaNuocQDGQ: res.data.datPhaiThuNhaNuocQDGQ ? res.data.datPhaiThuNhaNuocQDGQ : 0,
            datPhaiTraCongDanQDGQ: res.data.datPhaiTraCongDanQDGQ ? res.data.datPhaiTraCongDanQDGQ : 0,
            soNguoiDuocTraLaiQuyenLoi: res.data.soNguoiDuocTraLaiQuyenLoi ? res.data.soNguoiDuocTraLaiQuyenLoi : 0,

            soVuGiaiQuyetKhieuNai: res.data.soVuGiaiQuyetKhieuNai ? res.data.soVuGiaiQuyetKhieuNai : 0,
            ketQuaXLDGiaiQuyet: (res.data.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' || res.data.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI') ? res.data.ketQuaXLDGiaiQuyet : '',
            tienDoDoiThoai: this.props.isTTXMLai && res.data.ketQuaXLDGiaiQuyet == 'GIAO_THAM_TRA_XAC_MINH_LAI' ? '' : (res.data.ketQuaXLDGiaiQuyet ? (res.data.ketQuaXLDGiaiQuyet == 'DOI_THOAI' ? 'DOI_THOAI' : 'KHONG_DOI_THOAI') : ''),

            ketQuaXLDGiaiQuyetInit: (res.data.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' || res.data.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI') ? res.data.ketQuaXLDGiaiQuyet : '',
            showTienDoGiaiQuyet: (res.data.ketQuaXLDGiaiQuyet && (res.data.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' || res.data.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI')) ? true : false,
            lyDoBanHanhQuyetDinhGiaiQuyet: res.data.lyDoBanHanhQuyetDinhGiaiQuyet || '',
            lyDoBanHanhQuyetDinhDinhChi: res.data.lyDoBanHanhQuyetDinhDinhChi || '',

            noiDungGiaoTTXMLai: res.data.noiDungGiaoTTXMLai || '',
            soLanGiaiQuyetLai: res.data.soLanGiaiQuyetLai ? res.data.soLanGiaiQuyetLai : 0,
            ketQuaGiaiQuyetLan2: res.data.ketQuaGiaiQuyetLan2 ? res.data.ketQuaGiaiQuyetLan2 : '',
            noiDungKetLuanGiaiQuyetLai: res.data.noiDungKetLuanGiaiQuyetLai ? res.data.noiDungKetLuanGiaiQuyetLai : '',
            ketQuaGiaiQuyetKhac: res.data.ketQuaGiaiQuyetKhac ? res.data.ketQuaGiaiQuyetKhac : '',
            ketQuaThucHienKhac: res.data.ketQuaThucHienKhac ? res.data.ketQuaThucHienKhac : '',
            noiDungDoiThoai: res.data.noiDungDoiThoai ? res.data.noiDungDoiThoai : '',
            noiDungGiaoLapDuThao: res.data.noiDungGiaoLapDuThao ? res.data.noiDungGiaoLapDuThao : '',
            setHuongGiaiQuyet: false
          },()=> {
            this.checkOnlyState();
            this.renderAttachFile();
            this.getNgayHetHanLapDuThao();
            this.checkFileCoQuanDieuTra();
          });
          if (res.data.ngayHetHanGiaiQuyetTTXMLai) {
            this.setState({ngayHetHanGiaiQuyetTTXMLai: new Date(res.data.ngayHetHanGiaiQuyetTTXMLai)});
          }
          if (res.data.ngayHetHanTTXMLai) {
            this.setState({ngayHetHanTTXMLai: new Date(res.data.ngayHetHanTTXMLai)});
          }
        }
      });
    }
  }

  checkOnlyState() {
    if(this.props.dataNextStates.length == 1) {
      this.setState({
        nextState: this.props.dataNextStates[0].type
      },()=> {
        this.renderAttachFile();
        this.checkFileCoQuanDieuTra();
      })
    }
  }

  checkFileCoQuanDieuTra() {
    this.setState({
      allowAttachGiaoCoQuanDieuTra: false
    }, () => {
      if (this.state.giaoCoQuanDieuTra == false) {
        this.setState({
          allowAttachGiaoCoQuanDieuTra: true
        })
      } else {
        let taiLieuVanThuGiaoCoQuanDieuTra = [...this.props.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra];
        let data = [...this.props.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra];
        let dataCheck = data.filter(state => {
          return state.required && state.typeRequired == 'GIAO_CO_QUAN_DIEU_TRA'
        });

        if (dataCheck.length > 0) {
          this.setState({
            taiLieuVanThuGiaoCoQuanDieuTra: taiLieuVanThuGiaoCoQuanDieuTra,
            allowAttachGiaoCoQuanDieuTra: true
          })
        } else {
          let newItem = {
            ten: 'Văn bản về việc chuyển hồ sơ sang cơ quan điều tra',
            loaiTepDinhKem: '',
            soQuyetDinh: '',
            ngayQuyetDinh: '',
            tenFile: '',
            duongDan: '',
            progress: 0,
            required: true,
            typeRequired: 'GIAO_CO_QUAN_DIEU_TRA',
            newFile: true
          }

          this.setState({
            taiLieuVanThuGiaoCoQuanDieuTra: [
              ...taiLieuVanThuGiaoCoQuanDieuTra,
              newItem
            ],
            allowAttachGiaoCoQuanDieuTra: true
          })
        }
      }
    })
  }

  getNgayHetHanLapDuThao() {
    GiaiQuyetDonThu.actions.getNgayHetHanLapDuThao.request().then(res => {
      if(res.data) {
        this.setState({
          ngayHetHanGiaoLapDuThao: res.data
        })
      } else {
        this.setState({
          ngayHetHanGiaoLapDuThao: ''
        })
      }
    })
  }

  onClickClose() {
    this.props.handleBack();
  }

  handleChangeDate(name, e) {
    let date = e;
    if (e && e._d) {
      date = e._d;

    }
    this.setState({
      [name]: date
    }, () => {
      if (name == 'ngayRaThongBaoTTXM') {
        this.setState({
          loaiVanBanSuggest: 'VB_GTTXML',
          ngayQuyetDinhSuggest: this.state.ngayRaThongBaoTTXM
        });
        this.getThoiHanTTXMMacDinh();
      }
      this.props.handleChangeData();
    });
  }

  getParams() {
    let dataGiaiQuyetDon = this.state.dataGiaiQuyetDon;
    let params = getParams(dataGiaiQuyetDon, this.state.id);

    if(this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET') {
      params.soVanBan = this.state.soVanBan ? this.state.soVanBan : '';
      params.ngayBanHanh = this.state.ngayBanHanh ? moment(this.state.ngayBanHanh).add(7, 'hours').toISOString() : null;
      params.nguoiBanHanh = this.state.nguoiBanHanh ? {id: this.state.nguoiBanHanh} : null;
      params.lyDoBanHanhQuyetDinhGiaiQuyet = this.state.lyDoBanHanhQuyetDinhGiaiQuyet;

      if(this.state.giaoCoQuanDieuTra) {
        params.giaoCoQuanDieuTra = true;
        if (this.state.coQuanDieuTra) {
          params.coQuanDieuTra =  {
            id: Number(this.state.coQuanDieuTra)
          }
        }
        params.soVuGiaoCoQuanDieuTra = Number(this.state.soVuGiaoCoQuanDieuTra);
        params.soDoiTuongGiaoCoQuanDieuTra = Number(this.state.soDoiTuongGiaoCoQuanDieuTra);
        if (this.state.khoiTo) {
          params.khoiTo = true;
          params.soVuBiKhoiTo = this.state.soVuBiKhoiTo;
          params.soDoiTuongBiKhoiTo = this.state.soDoiTuongBiKhoiTo;
        } else {
          params.khoiTo = false;
          params.soVuBiKhoiTo = 0;
          params.soDoiTuongBiKhoiTo = 0;
        }
      } else {
        params.giaoCoQuanDieuTra = false;
        params.coQuanDieuTra = null;
        params.soVuGiaoCoQuanDieuTra = 0;
        params.soDoiTuongGiaoCoQuanDieuTra = 0;

        params.khoiTo = false;
        params.soVuBiKhoiTo = 0;
        params.soDoiTuongBiKhoiTo = 0;
      }

      params.quyetDinhGiaiQuyetKhieuNai = true;
      params.ketQuaGiaiQuyetKhac = this.state.ketQuaGiaiQuyetKhac;

      params.soLanGiaiQuyetLai = Number(this.state.soLanGiaiQuyetLai);

      if (Number(this.state.soLanGiaiQuyetLai) > 1) {
        params.ketQuaGiaiQuyetLan2 = this.state.ketQuaGiaiQuyetLan2 ? this.state.ketQuaGiaiQuyetLan2 : null;
      } else {
        params.ketQuaGiaiQuyetLan2 = null;
      }

      if ((this.state.ketQuaGiaiQuyetLan2 == 'HUY_SUA_QDGQ_LAN_I') && (Number(this.state.soLanGiaiQuyetLai) > 1)) {
        params.noiDungKetLuanGiaiQuyetLai = this.state.noiDungKetLuanGiaiQuyetLai;
      } else {
        params.noiDungKetLuanGiaiQuyetLai = '';
      }

      params.tienPhaiThuNhaNuocQDGQ = Number(this.state.tienPhaiThuNhaNuocQDGQ);
      params.tienPhaiTraCongDanQDGQ = Number(this.state.tienPhaiTraCongDanQDGQ);
      params.datPhaiThuNhaNuocQDGQ = Number(this.state.datPhaiThuNhaNuocQDGQ);
      params.datPhaiTraCongDanQDGQ = Number(this.state.datPhaiTraCongDanQDGQ);

      params.soVuGiaiQuyetKhieuNai = Number(this.state.soVuGiaiQuyetKhieuNai);
      params.ketLuanNoiDungKhieuNai = this.state.ketLuanNoiDungKhieuNai ? this.state.ketLuanNoiDungKhieuNai : null;
      params.tongSoNguoiXuLyHanhChinh = Number(this.state.tongSoNguoiXuLyHanhChinh);
      params.soNguoiDaBiXuLyHanhChinh = Number(this.state.soNguoiDaBiXuLyHanhChinh);
      params.soNguoiDuocTraLaiQuyenLoi = Number(this.state.soNguoiDuocTraLaiQuyenLoi);
    } else {
      params.soVanBan = '';
      params.ngayBanHanh = null;
      params.nguoiBanHanh = null;

      params.giaoCoQuanDieuTra = false;
      params.coQuanDieuTra = null;
      params.soVuGiaoCoQuanDieuTra = 0;
      params.soDoiTuongGiaoCoQuanDieuTra = 0;

      params.theoDoiThucHien = false;
      params.hinhThucTheoDoi = null;
      params.coQuanTheoDoi = null
      params.ketQuaThucHienTheoDoi = null;
      params.soVuBiKhoiTo = 0;
      params.soDoiTuongBiKhoiTo = 0;
      params.tienDaThuNhaNuoc = 0;
      params.datDaThuNhaNuoc = 0;
      params.tienDaTraCongDan = 0;
      params.datDaTraCongDan = 0;

      params.tienPhaiThuNhaNuoc = 0;
      params.datPhaiThuNhaNuoc = 0;
      params.tienPhaiTraCongDan = 0;
      params.datPhaiTraCongDan = 0;

      params.ketQuaThucHienKhac = '';

      params.khoiTo = false;
      params.soVuBiKhoiTo = 0;
      params.soDoiTuongBiKhoiTo = 0;

      params.quyetDinhGiaiQuyetKhieuNai = false;

      params.soLanGiaiQuyetLai = 0;
      params.ketQuaGiaiQuyetKhac = '';

      params.ketQuaGiaiQuyetLan2 = null;
      params.noiDungKetLuanGiaiQuyetLai = '';

      params.tienPhaiThuNhaNuocQDGQ = 0;
      params.tienPhaiTraCongDanQDGQ = 0;
      params.datPhaiThuNhaNuocQDGQ = 0;
      params.datPhaiTraCongDanQDGQ = 0;

      params.soVuGiaiQuyetKhieuNai = 0;
      params.ketLuanNoiDungKhieuNai = null;
      params.tongSoNguoiXuLyHanhChinh = 0;
      params.soNguoiDaBiXuLyHanhChinh = 0;

      params.soNguoiDuocTraLaiQuyenLoi = 0;
    }

    if (this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI') {
      params.lyDoBanHanhQuyetDinhDinhChi = this.state.lyDoBanHanhQuyetDinhDinhChi;
      params.soVanBan = this.state.soVanBan ? this.state.soVanBan : '';
      params.ngayBanHanh = this.state.ngayBanHanh ? moment(this.state.ngayBanHanh).add(7, 'hours').toISOString() : null;
      params.nguoiBanHanh = this.state.nguoiBanHanh ? {id: this.state.nguoiBanHanh} : null;
    }

    let selectedState = this.props.dataNextStates.filter(state => {
      return state.type == this.state.nextState
    });

    if(selectedState.length > 0) {
      params.nextState = {
        id: selectedState[0].stateId
      }
    } else {
      params.nextState = null
    }

    if(this.state.canBoGiaiQuyet) {
      params.canBoGiaiQuyet = {
        id: Number(this.state.canBoGiaiQuyet)
      }
    } else {
      params.canBoGiaiQuyet = null
    }

    if (this.state.phongBanGiaiQuyet) {
      params.phongBanGiaiQuyet = {
        id: Number(this.state.phongBanGiaiQuyet)
      };
    } else {
      params.phongBanGiaiQuyet = null
    }

    if (this.state.nextState === "TRUONG_PHONG_GIAO_VIEC_PHO_PHONG") {
      params.phoPhong = true;
    } else {
      params.phoPhong = false;
    }

    params.ketQuaXLDGiaiQuyet = this.state.ketQuaXLDGiaiQuyet ? this.state.ketQuaXLDGiaiQuyet : ( this.state.tienDoDoiThoai ? this.state.tienDoDoiThoai : null);
    if (this.state.nextState == 'TRUONG_PHONG_GIAO_VIEC_CAN_BO_SAU_KHI_NHAN_KET_QUA_TTXM') {
      params.ketQuaXLDGiaiQuyet = null;
    }

    if (this.state.tienDoDoiThoai == 'DOI_THOAI') {
      params.doiThoai = true;
      params.thoiGianDoiThoai = this.state.thoiGianDoiThoai ? moment(this.state.thoiGianDoiThoai).add(7, 'hours').toISOString() : null;
      params.diaDiemDoiThoai = this.state.diaDiemDoiThoai;
      params.noiDungDoiThoai = this.state.noiDungDoiThoai;
      params.noiDungGiaoLapDuThao = this.state.noiDungGiaoLapDuThao;
      params.ngayHetHanGiaoLapDuThao = this.state.ngayHetHanGiaoLapDuThao;
    } else if (this.props.nhanDuThao != true) {
      params.doiThoai = false;
      params.thoiGianDoiThoai = null;
      params.diaDiemDoiThoai = '';
      params.noiDungDoiThoai = '';
      params.noiDungGiaoLapDuThao = '';
      params.ngayHetHanGiaoLapDuThao = null;
    }

    if (this.state.tienDoDoiThoai == 'GIAO_THAM_TRA_XAC_MINH_LAI') {
      params.ngayHetHanGiaiQuyetTTXMLai = this.state.ngayHetHanGiaiQuyetTTXMLai ? moment(this.state.ngayHetHanGiaiQuyetTTXMLai).add(7, 'hours').toISOString() : null;
      params.ngayHetHanTTXMLai = this.state.ngayHetHanTTXMLai ? moment(this.state.ngayHetHanTTXMLai).add(7, 'hours').toISOString() : null;
      params.noiDungGiaoTTXMLai = this.state.noiDungGiaoTTXMLai || '';
    }

    return params;
  }

  handleSave(type){
    this.setState({
      onSave: true
    }, () => {

      this.setState({
        btnLoading: true,
        btnSaveLoading: true
      });
      let dataFileDinhKem = this.getListDataFileDinhKem();
      if (dataFileDinhKem.length > 0) {
        dataFileDinhKem.map((item, i) => {
          if (item.taiLieuVanThuId) {
            this.state.taiLieuVanThuUpdate[this.state.taiLieuVanThuUpdate.length] = {
              don: {
                id: Number(this.state.id)
              },
              id: item.taiLieuVanThuId,
              ten: item.ten,
              soQuyetDinh: item.soQuyetDinh,
              ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
              tenFile: item.tenFile,
              duongDan: item.duongDan,
              loaiTepDinhKem: item.loaiTepDinhKem,
              loaiQuyTrinh: item.loaiQuyTrinh,
              buocGiaiQuyet: item.buocGiaiQuyet,
              required: item.required,
              typeRequired: item.typeRequired ? item.typeRequired : ''
            };
          } else {
            this.state.taiLieuVanThu[this.state.taiLieuVanThu.length] = {
              don: {
                id: Number(this.state.id)
              },
              ten: item.ten,
              soQuyetDinh: item.soQuyetDinh,
              ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
              tenFile: item.tenFile,
              duongDan: item.duongDan,
              loaiTepDinhKem: loaiTepDinhKem,
              loaiQuyTrinh: loaiQuyTrinh,
              buocGiaiQuyet: item.phanLoaiQuyTrinh ? item.phanLoaiQuyTrinh : null,
              required: item.required,
              typeRequired: item.typeRequired ? item.typeRequired : ''
            };
          }
        });
      }

      if (this.state.nextState == 'TRUONG_PHONG_GIAO_VIEC_CAN_BO_SAU_KHI_NHAN_DU_THAO') {

        let dataQDGQ = [...this.props.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ];
        dataQDGQ.filter(state => {
          return state.typeRequired == 'QDGQ_LDT'
        }).map(item => {
          this.state.taiLieuVanThuDelete[this.state.taiLieuVanThuDelete.length] = {
            id: item.taiLieuVanThuId
          };
        });

        let dataGCCDT = [...this.props.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra];
        dataGCCDT.filter(state => {
          return state.typeRequired == 'GIAO_CO_QUAN_DIEU_TRA'
        }).map(item => {
          this.state.taiLieuVanThuDelete[this.state.taiLieuVanThuDelete.length] = {
            id: item.taiLieuVanThuId
          };
        });
      }

      if (this.state.nextState != 'KET_THUC' && this.props.nhanDuThao != true) {
        let dataGiaiQuyetDon = [...this.props.listTaiLieuVanThuGiaiQuyetDon];
        dataGiaiQuyetDon.filter(state => {
          return state.typeRequired == 'BB_DOI_THOAI'
        }).map(item => {
          this.state.taiLieuVanThuDelete[this.state.taiLieuVanThuDelete.length] = {
            id: item.taiLieuVanThuId
          };
        });

        let dataQDGQ = [...this.props.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ];
        dataQDGQ.filter(state => {
          return state.typeRequired == 'QDGQ_LDT'
        }).map(item => {
          this.state.taiLieuVanThuDelete[this.state.taiLieuVanThuDelete.length] = {
            id: item.taiLieuVanThuId
          };
        });

        let dataGCCDT = [...this.props.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra];
        dataGCCDT.filter(state => {
          return state.typeRequired == 'GIAO_CO_QUAN_DIEU_TRA'
        }).map(item => {
          this.state.taiLieuVanThuDelete[this.state.taiLieuVanThuDelete.length] = {
            id: item.taiLieuVanThuId
          };
        });
      } else {
        if (this.state.ketQuaXLDGiaiQuyet != 'DOI_THOAI' && this.props.nhanDuThao != true) {
          let dataGiaiQuyetDon = [...this.props.listTaiLieuVanThuGiaiQuyetDon];
          dataGiaiQuyetDon.filter(state => {
            return state.typeRequired == 'BB_DOI_THOAI'
          }).map(item => {
            this.state.taiLieuVanThuDelete[this.state.taiLieuVanThuDelete.length] = {
              id: item.taiLieuVanThuId
            };
          });
        }
        if (!this.state.giaoCoQuanDieuTra) {
          let dataGCCDT = [...this.props.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra];
          dataGCCDT.filter(state => {
            return state.typeRequired == 'GIAO_CO_QUAN_DIEU_TRA'
          }).map(item => {
            this.state.taiLieuVanThuDelete[this.state.taiLieuVanThuDelete.length] = {
              id: item.taiLieuVanThuId
            };
          });
        }
        if (this.state.ketQuaXLDGiaiQuyet != 'DA_CO_QUYET_DINH_GIAI_QUYET' && this.state.ketQuaXLDGiaiQuyet != 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI') {
          let dataQDGQ = [...this.props.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ];
          dataQDGQ.filter(state => {
            return state.typeRequired == 'QDGQ_LDT'
          }).map(item => {
            this.state.taiLieuVanThuDelete[this.state.taiLieuVanThuDelete.length] = {
              id: item.taiLieuVanThuId
            };
          });
        }
      }

      if (this.state.dataTaiLieuVanThuDelete.length > 0) {
        this.state.dataTaiLieuVanThuDelete.map(item => {
          this.state.taiLieuVanThuDelete[this.state.taiLieuVanThuDelete.length] = {
            id: item
          };
        });
      }

      let params = this.getParams();
      params.yKienGiaiQuyet = this.state.yKienGiaiQuyet;
      this.postTaiLieuVanThu(this.state.taiLieuVanThu, () => {
        this.updateTaiLieuVanThu(this.state.taiLieuVanThuUpdate, () => {
          this.deleteTaiLieuVanThu(this.state.taiLieuVanThuDelete, () => {
            this.props.saveGiaiQuyetDon(params);
          });
        });
      });

    })
  }

  handleGiaiQuyetDon(type) {
    this.setState({
      onSave: false
    }, ()=> {
      if(this.validateSubmitForm()) {
        this.setState({
          isOpen: false,
          btnLoading: true
        });
        let dataFileDinhKem = this.getListDataFileDinhKem();

        if (dataFileDinhKem.length > 0) {
          dataFileDinhKem.map((item, i) => {
            if (item.taiLieuVanThuId) {
              this.state.taiLieuVanThuUpdate[this.state.taiLieuVanThuUpdate.length] = {
                don: {
                  id: Number(this.state.id)
                },
                id: item.taiLieuVanThuId,
                ten: item.ten,
                soQuyetDinh: item.soQuyetDinh,
                ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                tenFile: item.tenFile,
                duongDan: item.duongDan,
                loaiTepDinhKem: item.loaiTepDinhKem,
                loaiQuyTrinh: item.loaiQuyTrinh,
                buocGiaiQuyet: item.buocGiaiQuyet,
                required: item.required,
                typeRequired: item.typeRequired ? item.typeRequired : ''
              };
            } else {
              this.state.taiLieuVanThu[this.state.taiLieuVanThu.length] = {
                don: {
                  id: Number(this.state.id)
                },
                ten: item.ten,
                soQuyetDinh: item.soQuyetDinh,
                ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
                tenFile: item.tenFile,
                duongDan: item.duongDan,
                loaiTepDinhKem: loaiTepDinhKem,
                loaiQuyTrinh: loaiQuyTrinh,
                buocGiaiQuyet: item.phanLoaiQuyTrinh ? item.phanLoaiQuyTrinh : null,
                required: item.required,
                typeRequired: item.typeRequired ? item.typeRequired : ''
              };
            }
          });
        }

        if (this.state.nextState == 'TRUONG_PHONG_GIAO_VIEC_CAN_BO_SAU_KHI_NHAN_DU_THAO') {
          let dataQDGQ = [...this.props.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ];
          dataQDGQ.filter(state => {
            return state.typeRequired == 'QDGQ_LDT'
          }).map(item => {
            this.state.taiLieuVanThuDelete[this.state.taiLieuVanThuDelete.length] = {
              id: item.taiLieuVanThuId
            };
          });

          let dataGCCDT = [...this.props.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra];
          dataGCCDT.filter(state => {
            return state.typeRequired == 'GIAO_CO_QUAN_DIEU_TRA'
          }).map(item => {
            this.state.taiLieuVanThuDelete[this.state.taiLieuVanThuDelete.length] = {
              id: item.taiLieuVanThuId
            };
          });
        }

        if (this.state.nextState != 'KET_THUC' && this.props.nhanDuThao != true) {
          let dataGiaiQuyetDon = [...this.props.listTaiLieuVanThuGiaiQuyetDon];
          dataGiaiQuyetDon.filter(state => {
            return state.typeRequired == 'BB_DOI_THOAI'
          }).map(item => {
            this.state.taiLieuVanThuDelete[this.state.taiLieuVanThuDelete.length] = {
              id: item.taiLieuVanThuId
            };
          });

          let dataQDGQ = [...this.props.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ];
          dataQDGQ.filter(state => {
            return state.typeRequired == 'QDGQ_LDT'
          }).map(item => {
            this.state.taiLieuVanThuDelete[this.state.taiLieuVanThuDelete.length] = {
              id: item.taiLieuVanThuId
            };
          });

          let dataGCCDT = [...this.props.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra];
          dataGCCDT.filter(state => {
            return state.typeRequired == 'GIAO_CO_QUAN_DIEU_TRA'
          }).map(item => {
            this.state.taiLieuVanThuDelete[this.state.taiLieuVanThuDelete.length] = {
              id: item.taiLieuVanThuId
            };
          });
        } else {
          if (this.state.ketQuaXLDGiaiQuyet != 'DOI_THOAI' && this.props.nhanDuThao != true) {
            let dataGiaiQuyetDon = [...this.props.listTaiLieuVanThuGiaiQuyetDon];
            dataGiaiQuyetDon.filter(state => {
              return state.typeRequired == 'BB_DOI_THOAI'
            }).map(item => {
              this.state.taiLieuVanThuDelete[this.state.taiLieuVanThuDelete.length] = {
                id: item.taiLieuVanThuId
              };
            });
          }
          if (!this.state.giaoCoQuanDieuTra) {
            let dataGCCDT = [...this.props.listTaiLieuVanThuGiaiQuyetDonGiaoCoQuanDieuTra];
            dataGCCDT.filter(state => {
              return state.typeRequired == 'GIAO_CO_QUAN_DIEU_TRA'
            }).map(item => {
              this.state.taiLieuVanThuDelete[this.state.taiLieuVanThuDelete.length] = {
                id: item.taiLieuVanThuId
              };
            });
          }
          if (this.state.ketQuaXLDGiaiQuyet != 'DA_CO_QUYET_DINH_GIAI_QUYET' && this.state.ketQuaXLDGiaiQuyet != 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI') {
            let dataQDGQ = [...this.props.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ];
            dataQDGQ.filter(state => {
              return state.typeRequired == 'QDGQ_LDT'
            }).map(item => {
              this.state.taiLieuVanThuDelete[this.state.taiLieuVanThuDelete.length] = {
                id: item.taiLieuVanThuId
              };
            });
          }
        }

        if (this.state.dataTaiLieuVanThuDelete.length > 0) {
          this.state.dataTaiLieuVanThuDelete.map(item => {
            this.state.taiLieuVanThuDelete[this.state.taiLieuVanThuDelete.length] = {
              id: item
            };
          });
        }
        let _params = this.getParams();
        let selectedState = this.state.dataNextStates.filter(state => state.type == this.state.nextState);
        let params = {};
        let msgName = '';
        if (type == 'giaoCanBo') {
          params = {
            canBoXuLyChiDinh: {
              id: Number(this.state.canBoGiaiQuyet)
            },
            thongTinGiaiQuyetDon: {
              id: Number(this.state.thongTinGiaiQuyetDonId)
            },
            nextState: {
              id: Number(selectedState[0].stateId)
            },
            yKienGiaiQuyet: this.state.yKienGiaiQuyet
          };
          msgName = 'gqdGiaoViec';
          if (this.state.nextState === "TRUONG_PHONG_GIAO_VIEC_PHO_PHONG") {
            params = {
              ...params,
              phoPhong: true,
              phongBanGiaiQuyet : {
                id: Number(this.state.coQuanQuanLyNguoiDung.id)
              }
            };
          }
        } else if (type == 'openDialogVanPhong' || type == 'openDialogNoiChinh') {
          params = {
            phongBanGiaiQuyet: {
              id: Number(this.state.phongBanGiaiQuyet)
            },
            thongTinGiaiQuyetDon: {
              id: Number(this.state.thongTinGiaiQuyetDonId)
            },
            nextState: {
              id: Number(selectedState[0].stateId)
            },
            yKienGiaiQuyet: this.state.yKienGiaiQuyet
          }
          msgName = 'xldChuyenDon';
        } else if (type == 'openDialogLuuHoSo') {
          if(this.state.donViTheoDoiThucHien) {
            _params.donViTheoDoiThucHien = {
              id: Number(this.state.donViTheoDoiThucHien)
            }
          }
          selectedState = this.props.dataNextStates.filter(state => {
            return state.type == 'CAN_BO_GUI_YEU_CAU_THEO_DOI_THUC_HIEN'
          });

          params = {
            thongTinGiaiQuyetDon: {
              id: Number(this.props.thongTinGiaiQuyetDonId)
            },
            donViTheoDoiThucHien: {
              id: Number(this.state.donViTheoDoiThucHien)
            },
            nextState: {
              id: Number(selectedState[0].stateId)
            }
          }
          params.yKienGiaiQuyet = this.state.lyDoBanHanhQuyetDinhDinhChi;
          if (this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET') {
            params.yKienGiaiQuyet = this.state.lyDoBanHanhQuyetDinhGiaiQuyet;
          }
          msgName = 'gqdChuyenTheoDoi';
        } else if (type == 'openDialogGiaoTTXML') {
          selectedState = this.props.dataNextStates.filter(state => state.type === 'CAN_BO_GIAO_TTXM_LAI');
          params = {
            nextState: {
              id: Number(selectedState[0].stateId)
            },
            thongTinGiaiQuyetDon: {
              id: Number(this.props.thongTinGiaiQuyetDonId)
            },
            yKienGiaiQuyet: this.state.noiDungGiaoTTXMLai
          }
          msgName = 'guiTTXMLai';
          if (this.state.ngayRaThongBaoTTXM) {
            params.ngayRaThongBaoTTXM = moment(this.state.ngayRaThongBaoTTXM).add(7, 'hours').toISOString();
          }
        } else if (type === 'giaoPhongBan') {
          selectedState = this.props.dataNextStates.find(state => state.type === this.state.nextState);
          params = {
            thongTinGiaiQuyetDon: {
              id: Number(this.props.thongTinGiaiQuyetDonId)
            },
            yKienGiaiQuyet: this.state.yKienGiaiQuyet || ''
          };

          if (selectedState && selectedState.stateId) {
            params.nextState = { id: Number(selectedState.stateId) };
          }
          if (this.state.phongBanGiaiQuyet) {
            params.phongBanGiaiQuyet = { id: Number(this.state.phongBanGiaiQuyet) };
          }
          msgName = 'gqdGiaoViec';
        }
        else  {
          selectedState = this.props.dataNextStates.filter(state => {
            return state.type == 'CAN_BO_GIAO_DON_VI_TTXM_LAP_DU_THAO'
          });

          params = {
            thongTinGiaiQuyetDon: {
              id: Number(this.props.thongTinGiaiQuyetDonId)
            },
            nextState: {
              id: Number(selectedState[0].stateId)
            },
            yKienGiaiQuyet: this.state.noiDungGiaoLapDuThao ? this.state.noiDungGiaoLapDuThao : ''
          }
          msgName = 'gqdGuiDuThao';
        }
        this.postTaiLieuVanThu(this.state.taiLieuVanThu, () => {
          this.updateTaiLieuVanThu(this.state.taiLieuVanThuUpdate, () => {
            this.deleteTaiLieuVanThu(this.state.taiLieuVanThuDelete, () => {
              this.props.updateGiaiQuyetDon(_params, params, msgName);
            });
          });
        });
      }
    })
  }

  onFileChange(data, type) {
    let dataFileDinhKem = {...this.state.dataFileDinhKem};
    if (type == 'QUYET_DINH_GIAI_QUYET') {
      dataFileDinhKem.quyetDinhGiaiQuyet = data;
      let fileQD = data.filter(item => {
        return item.typeRequired == 'QDGQ_LDT'
      });
      this.setState ({
        ngayBanHanh: fileQD.length ? fileQD[0].ngayQuyetDinh : '',
        soVanBan: fileQD.length ? fileQD[0].soQuyetDinh : ''
      });
    } else if (type == 'GIAO_CO_QUAN_DIEU_TRA') {
      dataFileDinhKem.giaoCoQuanDieuTra = data;
    } else if (type == 'GIA_HAN') {
      dataFileDinhKem.giaHan = data;
    } else {
      dataFileDinhKem.data = data;
      let ttxmlDate = data.filter(item => {
        return item.typeRequired == 'VB_GTTXML';
      });
      if (ttxmlDate.length) {
        this.state.ngayRaThongBaoTTXM = ttxmlDate[0].ngayQuyetDinh;
      }
      this.getThoiHanTTXMMacDinh();
    }
    this.setState ({
      dataFileDinhKem: dataFileDinhKem
    });
    this.props.handleChangeData();
  }

  onFileRemove(id, data, type) {
    this.setState({
      dataTaiLieuVanThuDelete: [
        ...this.state.dataTaiLieuVanThuDelete,
        id
      ]
    });

    if (type == 'QUYET_DINH_GIAI_QUYET') {
      let dataFileDinhKem = this.state.dataFileDinhKem;

      dataFileDinhKem.quyetDinhGiaiQuyet = data

      this.setState ({
        dataFileDinhKem: dataFileDinhKem
      });
    } else if (type == 'GIAO_CO_QUAN_DIEU_TRA') {
      let dataFileDinhKem = this.state.dataFileDinhKem;

      dataFileDinhKem.giaoCoQuanDieuTra = data

      this.setState ({
        dataFileDinhKem: dataFileDinhKem
      });
    } else if (type == 'GIA_HAN') {
      let dataFileDinhKem = this.state.dataFileDinhKem;

      dataFileDinhKem.giaHan = data

      this.setState ({
        dataFileDinhKem: dataFileDinhKem
      });
    } else {
      let dataFileDinhKem = this.state.dataFileDinhKem;

      dataFileDinhKem.data = data

      this.setState ({
        dataFileDinhKem: dataFileDinhKem
      });
    }
    this.props.handleChangeData();

  }

  getListDataFileDinhKem() {
    let dataFileDinhKem = []
    let Data = this.state.dataFileDinhKem;

    if (Data.data.length > 0) {
      Data.data.map(state => {
        dataFileDinhKem[dataFileDinhKem.length] = state
      })
    }

    if (Data.quyetDinhGiaiQuyet.length > 0 && (this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' || this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI')) {
      Data.quyetDinhGiaiQuyet.map(state => {
        dataFileDinhKem[dataFileDinhKem.length] = state
      })
    }

    if (Data.giaoCoQuanDieuTra.length > 0 && this.state.giaoCoQuanDieuTra) {
      Data.giaoCoQuanDieuTra.map(state => {
        dataFileDinhKem[dataFileDinhKem.length] = state
      })
    }

    if (Data.giaHan.length > 0 && (this.state.giaHanGiaiQuyet)) {
      Data.giaHan.map(state => {
        dataFileDinhKem[dataFileDinhKem.length] = state
      })
    }

    return dataFileDinhKem;
  }

  // Cap nhat tep dinh kem
  updateTaiLieuVanThu(fileList, callback) {
    if (fileList && fileList.length) {
      let params = {
        taiLieuVanThus: fileList
      };
      GiaiQuyetDonThu.actions.updateTaiLieuDinhKem.request('', params).then(res => {
        callback();
      }).catch(error => {
        if (error.response) {

        }
        callback();
      });
    } else {
      callback();
    }
  }

  // Them tep dinh kem
  postTaiLieuVanThu(fileList, callback) {
    if (fileList && fileList.length) {
      let params = {
        taiLieuVanThus: fileList
      };
      GiaiQuyetDonThu.actions.postTaiLieuDinhKem.request('', params).then(res => {
        callback();
      }).catch(error => {
        if (error.response) {

        }
        callback();
      });
    } else {
      callback();
    }
  }

  // Xoa tep dinh kem
  deleteTaiLieuVanThu(fileList, callback) {
    if (fileList && fileList.length) {
      let params = {
        taiLieuVanThus: fileList
      };
      GiaiQuyetDonThu.actions.deleteTaiLieuDinhKem.request('', params).then(res => {
        callback();
      }).catch(error => {
        if (error.response) {

        }
        callback();
      });
    } else {
      callback();
    }
  }

  validateSubmitForm() {
    let pass = true;
    this.props.validators['formTaoDon'].map(validator => {
      if(pass) {
        pass = validator.validate();
      } else {
        validator.validate();
      }
    });
    return pass;
  }

  openDialog(type) {
    if (this.validateSubmitForm()) {
      this.setState({
        [type]: true
      });
    }
  }

  closeDialog(type) {
    this.setState({
      [type]: false
    });
  }

  onSuccess(type) {
    this.closeDialog(type);
    this.handleGiaiQuyetDon(type);
  }

  compareDate(firstDate, secondDate, type) {
    var firstTime = firstDate.getTime();
    var secondTime = secondDate.getTime()

    if (firstTime > secondTime || (firstTime == secondTime  && type == 'show')) {
      return true
    } else {
      return false
    }
  }

  closeDialogConfirm() {
    this.state.open = false;
    this.state.ketQuaXLDGiaiQuyet = this.state.ketQuaXLDGiaiQuyet;
    this.setState({
      ...this.state
    },()=> {
      this.renderAttachFile();
    })

  }

  onSuccessDialogConfirm() {
    this.state.open = false;
    this.state.ketQuaXLDGiaiQuyet = this.state.valueKetQua;
    this.setState({
      ...this.state
    },()=> {
      this.renderAttachFile();
    })

  }

  renderAttachFile() {
    let DataTaiLieuVanThu = [...this.props.listTaiLieuVanThuGiaiQuyetDon];
    let DataTaiLieuVanThuView = [...this.props.listTaiLieuVanThuGiaiQuyetDon];

    let listTaiLieuVanThuGiaiQuyetDon = [];

    let listTaiLieuVanThuGiaiQuyetDonView = [];

    if(this.props.nhanDuThao == true) {
      listTaiLieuVanThuGiaiQuyetDon = DataTaiLieuVanThu.filter(state => {
        return this.compareDate(new Date(state.ngayTao), new Date(this.state.dataGiaiQuyetDon.ngayKetThucGiaoLapDuThao), 'action');
      })

      listTaiLieuVanThuGiaiQuyetDonView = DataTaiLieuVanThuView.filter(state => {
        return this.compareDate(new Date(this.state.dataGiaiQuyetDon.ngayKetThucGiaoLapDuThao), new Date(state.ngayTao), 'show');
      })
    } else {
      listTaiLieuVanThuGiaiQuyetDon = DataTaiLieuVanThu.filter(state => {
        return this.compareDate(new Date(state.ngayTao), new Date(this.state.dataGiaiQuyetDon.ngayTraBaoCaoTTXM), 'action');
      })

      listTaiLieuVanThuGiaiQuyetDonView = DataTaiLieuVanThuView.filter(state => {
        return this.compareDate(new Date(this.state.dataGiaiQuyetDon.ngayTraBaoCaoTTXM), new Date(state.ngayTao), 'show');
      })
    }
    if (this.state.tienDoDoiThoai == 'DOI_THOAI' && this.state.nextState == 'KET_THUC' && (this.state.valueKetQua != 'DA_CO_QUYET_DINH_GIAI_QUYET' && this.state.valueKetQua != 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI')) {
      let data = [...listTaiLieuVanThuGiaiQuyetDon];
      let dataCheck = data.filter(item => {
        return item.required && item.typeRequired == 'BB_DOI_THOAI'
      })
      if (dataCheck.length > 0) {
        //Do nothing
      } else {
        listTaiLieuVanThuGiaiQuyetDon[listTaiLieuVanThuGiaiQuyetDon.length] = {
          ten: 'Biên bản đối thoại',
          loaiTepDinhKem: '',
          soQuyetDinh: '',
          ngayQuyetDinh: '',
          tenFile: '',
          duongDan: '',
          progress: 0,
          required: true,
          typeRequired: 'BB_DOI_THOAI',
          newFile: true
        }
      }

      this.setState({
        listTaiLieuVanThuGiaiQuyetDon: listTaiLieuVanThuGiaiQuyetDon,
        listTaiLieuVanThuGiaiQuyetDonView: listTaiLieuVanThuGiaiQuyetDonView,
        allowAttach: true
      })
    } else {
      this.setState({
        allowAttach: false
      })
      let data = [...listTaiLieuVanThuGiaiQuyetDon];
      let dataForFillter = [...listTaiLieuVanThuGiaiQuyetDon];

      let dataFillter = dataForFillter.filter(item => {
        return item.typeRequired != 'BB_DOI_THOAI'
      })
      let dataTTXML = dataForFillter.filter(item => {
        return item.typeRequired == 'VB_GTTXML'
      })

      let dataCheck = data.filter(item => {
        return item.taiLieuVanThuId && item.typeRequired == 'BB_DOI_THOAI'
      })
      if (dataCheck.length > 0) {
        dataCheck.map(item => {
          this.state.taiLieuVanThuDelete[this.state.taiLieuVanThuDelete.length] = {
            id: item.taiLieuVanThuId
          };
        })
      }
      //check file TTXM Lai
      if ((this.state.nextState == 'KET_THUC' || this.state.valueSelectBox === 'TU_GIAI_QUYET') && this.state.tienDoDoiThoai == 'GIAO_THAM_TRA_XAC_MINH_LAI' && !dataTTXML.length) {
        dataFillter = [...dataFillter, {
          ten: this.props.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? 'Văn bản xác minh nội dung kiến nghị, phản ánh lại' : 'Văn bản giao TTXM lại',
          loaiTepDinhKem: '',
          soQuyetDinh: '',
          ngayQuyetDinh: '',
          tenFile: '',
          duongDan: '',
          progress: 0,
          required: true,
          typeRequired: 'VB_GTTXML',
          newFile: true
        }];
      }
      this.setState({
        listTaiLieuVanThuGiaiQuyetDon: dataFillter,
        listTaiLieuVanThuGiaiQuyetDonView: listTaiLieuVanThuGiaiQuyetDonView,
        allowAttach: true
      })
    }
  }

  checkHuongGiaiQuyet() {
    let ThamSo = localStorage.getItem('thamSo') ? JSON.parse(localStorage.getItem('thamSo')) : [];
    let userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
    if (
      ThamSo.length > 0 &&
      this.state.nextStateInit == '' &&
      userInfo != {} &&
      this.state.setHuongGiaiQuyet == false && (
        this.state.loaiDon == 'DON_KHIEU_NAI' ||
        this.state.loaiDon == 'DON_TO_CAO' ||
        this.state.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH'
        )
      ) {

      if (checkThamSo() == null && this.props.dataNextStates.length > 1) {
        this.setState({
          setHuongGiaiQuyet: true,
          allowHuongGiaiQuyet: true
        })
      } else if (checkThamSo() == 'CQQL_BAN_TIEP_CONG_DAN' && this.props.roleGQ === "truongPhongBanTiepCongDan") {
        this.setState({
          // nextState: this.props.roleGQ === 'truongPhongBanTiepCongDan' ? 'KET_THUC' : 'TRUONG_PHONG_NHAN_KET_QUA_TTXM',
          setHuongGiaiQuyet: true,
          allowHuongGiaiQuyet: false
        }, () => {
          this.checkPhongBan()
        })
      } else if (checkThamSo() == 'CQQL_PHONG_NOI_CHINH') {
        let dataNextStates = [...this.props.dataNextStates];
        let dataFilter = dataNextStates.filter(state => {
          return state.type == 'TRUONG_PHONG_GIAO_VIEC_CAN_BO_SAU_KHI_NHAN_KET_QUA_TTXM'
        })

        if (dataFilter.length > 0) {
          this.setState({
            nextState: this.state.phoPhong ? "TRUONG_PHONG_GIAO_VIEC_PHO_PHONG" : ((this.props.truongPhongThuHoi == true) ? 'KET_THUC' : 'TRUONG_PHONG_GIAO_VIEC_CAN_BO_SAU_KHI_NHAN_KET_QUA_TTXM'),
            setHuongGiaiQuyet: true,
            allowHuongGiaiQuyet: true
          })
        } else {
          this.setState({
            nextState: this.state.phoPhong ? "TRUONG_PHONG_GIAO_VIEC_PHO_PHONG" : 'TRUONG_PHONG_GIAO_VIEC_CAN_BO_SAU_KHI_NHAN_DU_THAO',
            setHuongGiaiQuyet: true,
            allowHuongGiaiQuyet: true
          })
        }
      }
    }
  }

  checkPhongBan() {
    let ThamSo = localStorage.getItem('thamSo') ? JSON.parse(localStorage.getItem('thamSo')) : [];
    if (this.state.loaiDon == 'DON_KHIEU_NAI' || this.state.loaiDon == 'DON_TO_CAO') {
      let dataFilter = ThamSo.filter(state => {
        return state.ten == 'CQQL_PHONG_NOI_CHINH'
      })

      if (dataFilter.length > 0) {
        this.setState({
          phongBanGiaiQuyet: Number(dataFilter[0].giaTri),
          typeButton: 'PHONG_NOI_CHINH'
        })
      }
    } else if (this.state.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH') {
      let dataFilter = ThamSo.filter(state => {
        return state.ten == 'CQQL_VAN_PHONG_UBND_THANH_PHO'
      })

      if (dataFilter.length > 0) {
        this.setState({
          phongBanGiaiQuyet: Number(dataFilter[0].giaTri),
          typeButton: 'VAN_PHONG_UBND'
        })
      }
    }
  }

  render() {
    let ketQuaGiaiQuyetDon = this.state.dataKetQuaGiaiQuyetDon.filter(state => {
      return state.giaTri == this.state.ketQuaXLDGiaiQuyet
    });
    let lb1 = this.props.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? 'xác minh đề xuất' : 'TTXM';
    let lb2 = this.props.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? 'xác minh đề xuất' : 'thẩm tra xác minh';
    let txtTuGQ = "Tự giải quyết";
    return (
      <section className="wrap-block">
        <div className="row pl10 pr10">
          <div className="col-100 no-gutter">
            <BlockBaoCaoKQTTXM donInfo={this.props.donInfo} thongTinGQD={this.state.dataGiaiQuyetDon}/>

            <ShowIf condition={this.props.loaiDon == 'DON_TO_CAO' && this.state.dataGiaiQuyetDon.giaHanGiaiQuyet}>
              <div>
                <div className="col-100">
                  <h3 className="text-12 txt-upper txt-bold mb10 mt0">Gia hạn giải quyết tố cáo</h3>
                </div>
                <Text red={true} className="col-25 mb10" label="Gia hạn đến ngày:" value={this.state.dataGiaiQuyetDon.ngayHetHanSauKhiGiaHanGiaiQuyet ? moment(this.state.dataGiaiQuyetDon.ngayHetHanSauKhiGiaHanGiaiQuyet).format('DD/MM/YYYY') : ''}/>
                <TextMessage className="col-100 mb5" label="Lý do gia hạn:" value={this.state.dataGiaiQuyetDon.lyDoGiaHanGiaiQuyet ? this.state.dataGiaiQuyetDon.lyDoGiaHanGiaiQuyet : ''}/>
              </div>
            </ShowIf>
            <ShowIf condition={this.props.nhanDuThao == true}>
              <div>
                <div className="col-100 pt5 pb15">
                  <span className="line-border"></span>
                </div>
                <div className="col-100">
                  <div className="col-100 no-gutter mt5 pb10">
                    <h2 className="title-12 mb15">Đối thoại</h2>
                    <div className="row pl10 pr10">
                      <Text className="col-25 mb10" label="Thời gian đối thoại:" value={this.state.dataGiaiQuyetDon && this.state.dataGiaiQuyetDon.thoiGianDoiThoai ? moment(this.state.dataGiaiQuyetDon.thoiGianDoiThoai).format('DD/MM/YYYY') : ''}/>
                      <Text className="col-75 mb10" label="Địa điểm:" value={this.state.dataGiaiQuyetDon && this.state.dataGiaiQuyetDon.diaDiemDoiThoai ? this.state.dataGiaiQuyetDon.diaDiemDoiThoai : ''}/>
                      <TextMessage className="col-100 mb0-18" label="Nội dung, kết quả đối thoại:" value={this.state.dataGiaiQuyetDon && this.state.dataGiaiQuyetDon.noiDungDoiThoai ? this.state.dataGiaiQuyetDon.noiDungDoiThoai : ''}/>
                    </div>
                  </div>
                </div>
                <div className="col-100 pt5 pb15">
                  <span className="line-border"></span>
                </div>
                <div className="col-100">
                  <div className="col-100 no-gutter mt5 pb10">
                    <h2 className="title-12 mb15">Giao dự thảo quyết định giải quyết khiếu nại</h2>
                    <div className="row pl10 pr10">
                      <Text className="col-25 mb10" label="Thời gian trình dự thảo:" red value={this.state.dataGiaiQuyetDon && this.state.dataGiaiQuyetDon.ngayHetHanGiaoLapDuThao ? moment(this.state.dataGiaiQuyetDon.ngayHetHanGiaoLapDuThao).format('DD/MM/YYYY') : ''}/>
                      <TextMessage className="col-100 mb0-18" label="Ý kiến xử lý:" value={this.state.dataGiaiQuyetDon && this.state.dataGiaiQuyetDon.noiDungGiaoLapDuThao ? this.state.dataGiaiQuyetDon.noiDungGiaoLapDuThao : ''}/>
                    </div>
                  </div>
                </div>
                <div className="col-100 pt5 pb15">
                  <span className="line-border"></span>
                </div>
                <div className="col-100">
                  <div className="col-100 no-gutter mt5 pb10">
                    <h2 className="title-12 mb15">Dự thảo quyết định giải quyết khiếu nại</h2>
                    <div className="row pl10 pr10">
                      <Text className="col-25 mb10" label="Ngày trình dự thảo:" value={this.state.dataGiaiQuyetDon && this.state.dataGiaiQuyetDon.ngayKetThucGiaoLapDuThao ? moment(this.state.dataGiaiQuyetDon.ngayKetThucGiaoLapDuThao).format('DD/MM/YYYY') : ''}/>
                      <TextMessage className="col-100 mb0-18" label="Tóm tắt nội dung kết quả đối thoại:" value={this.state.dataGiaiQuyetDon && this.state.dataGiaiQuyetDon.noiDungKetLuanDuThao ? this.state.dataGiaiQuyetDon.noiDungKetLuanDuThao : ''}/>
                    </div>
                  </div>
                </div>
              </div>
            </ShowIf>
          </div>
        </div>
        <div className="wrap-big-line pt5 pb20">
          <span className="big-border"></span>
        </div>
        <h2 className="title-14 mb15">Thông tin giải quyết</h2>
        <div className="row pl10 pr10">
        <ShowIf condition={!this.state.showTienDoGiaiQuyet}>
          <ShowIf condition={this.props.loaiDon !== "DON_TRANH_CHAP_DAT" && !this.state.allowHuongGiaiQuyet && checkThamSo() === 'CQQL_BAN_TIEP_CONG_DAN' && this.props.roleGQ === "truongPhongBanTiepCongDan"}>
            <DropDown
              require
              label=''
              selectedValue={ this.state.valueSelectBox }
              options={ this.state.dataSelectBox }
              keyName='giaTri'
              label='Hướng giải quyết'
              valueName='ten'
              disable={this.state.ketQuaXLDGiaiQuyet !== '' ? true : false}
              className='col-25'
              onChange={ this.onChange.bind(this, 'valueSelectBox') }
              placeholder='--Chọn--'
              name='valueSelectBox'/>
          </ShowIf>
        </ShowIf>
        </div>
        <form className="form-action">
          <div className="row pl10 pr10">
            <ShowIf condition={!this.state.showTienDoGiaiQuyet}>
              <ShowIf condition={this.state.allowHuongGiaiQuyet && (this.state.ketQuaXLDGiaiQuyetInit !== 'DA_CO_QUYET_DINH_GIAI_QUYET' && this.state.ketQuaXLDGiaiQuyetInit !== 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI')}>
                <DropDownMulipleUse
                  onRef={select => (this.select = select)}
                  className="col-25"
                  donId={this.state.id}
                  require
                  isValid={this.state.validate}
                  data={this.state.dataNextStates}
                  disable={this.state.ketQuaXLDGiaiQuyet !== '' ? true : false}
                  bindValidator={this}
                  selectedValue={this.state.nextState}
                  label="Hướng giải quyết"
                  keyName='type'
                  name="huongGiaiQuyet"
                  valueName='tenVietTat'
                  onChange={this.onChange.bind(this, 'nextState')}/>
              </ShowIf>
            </ShowIf>
            <ShowIf condition={this.state.showTienDoGiaiQuyet}>
              <p className="attach-file-description mb10 pl5 pr5">Hướng giải quyết</p>
              <Text className="col-25 mb10" label='' value={txtTuGQ}/>
            </ShowIf>
            <ShowIf condition={this.state.nextState == 'TRUONG_PHONG_NHAN_KET_QUA_TTXM'}>
              <ShowIf condition={this.state.typeButton != 'PHONG_NOI_CHINH' && this.state.typeButton != 'VAN_PHONG_UBND'}>
                <DropDownMulipleUse
                  selectedValue={this.state.phongBanGiaiQuyet}
                  require
                  bindValidator={this}
                  className="col-25"
                  keyName='coQuanQuanLyId'
                  valueName='ten'
                  name="phongBanGiaiQuyet"
                  label="Phòng ban giải quyết"
                  data={this.state.dataPhongBan}
                  onChange={this.onChange.bind(this, 'phongBanGiaiQuyet')}
                />
              </ShowIf>
              <TextArea value={this.state.yKienGiaiQuyet} className="areal-wrap col-100" label="Ý kiến xử lý" placeholder="Nhập ý kiến" onChange={this.onChange.bind(this, 'yKienGiaiQuyet')} name="textareaChonCanBoGiaiQuyet"/>
            </ShowIf>
            <ShowIf condition={this.state.nextState === 'NHANKQDUTHAO_GIAO_PHONG_CUNG_CAP' && this.state.typeButton !== "PHONG_NOI_CHINH"}>
              <DropDownChonPhongBanThuocCoQuan
                className="col-25"
                require
                bindValidator={this}
                selectedValue={this.state.phongBanGiaiQuyet}
                isValid={this.props.validate}
                onChange={this.onChange.bind(this, 'phongBanGiaiQuyet')}
                name="dropdownChonPhongBanThuocCoQuan" />
              <TextArea value={this.state.yKienGiaiQuyet} className="areal-wrap col-100" label="Ý kiến xử lý" placeholder="Nhập ý kiến" onChange={this.onChange.bind(this, 'yKienGiaiQuyet')} name="textareaChonCanBoGiaiQuyet"/>
            </ShowIf>
            <ShowIf condition={this.state.nextState === 'TRUONG_PHONG_GIAO_VIEC_PHO_PHONG'}>
              <DropDownChonCanBoGiaiQuyet
                isValid={this.state.validate}
                selectedValue={this.state.canBoGiaiQuyet}
                require
                vaiTro="PHO_PHONG"
                coQuanQuanLyId={this.state.coQuanQuanLyNguoiDung.id}
                bindvaiTroValidator={this}
                className="col-25"
                label="Chọn phó phòng"
                onChange={this.onChange.bind(this, 'canBoGiaiQuyet')}
                name="dropdownChonCanBoGiaiQuyet"
              />
              <TextArea value={this.state.yKienGiaiQuyet} className="areal-wrap col-100" label="Ý kiến xử lý" placeholder="Nhập ý kiến" onChange={this.onChange.bind(this, 'yKienGiaiQuyet')} name="textareaChonCanBoGiaiQuyet"/>
            </ShowIf>
            <ShowIf condition={this.state.nextState == 'TRUONG_PHONG_GIAO_VIEC_CAN_BO_SAU_KHI_NHAN_KET_QUA_TTXM' || this.state.nextState == 'TRUONG_PHONG_GIAO_VIEC_CAN_BO_SAU_KHI_NHAN_DU_THAO'}>
              <DropDownChonCanBoGiaiQuyet
                selectedValue={this.state.canBoGiaiQuyet}
                require
                coQuanQuanLyId={this.state.coQuanQuanLyNguoiDung.id}
                vaiTro={vaiTro}
                bindValidator={this}
                className="col-25"
                label={checkThamSo() == 'CQQL_VAN_PHONG_UBND_THANH_PHO' ? 'Phòng ban giải quyết' : 'Công chức giải quyết'}
                onChange={this.onChange.bind(this, 'canBoGiaiQuyet')}
                name="dropdownChonCanBoGiaiQuyet"
              />
              <TextArea value={this.state.yKienGiaiQuyet} className="areal-wrap col-100" label="Ý kiến xử lý" placeholder="Nhập ý kiến" onChange={this.onChange.bind(this, 'yKienGiaiQuyet')} name="textareaChonCanBoGiaiQuyet"/>
            </ShowIf>
            <ShowIf condition={(this.state.nextState === 'KET_THUC' && this.state.valueSelectBox === "") || (checkThamSo() === 'CQQL_BAN_TIEP_CONG_DAN' && this.state.valueSelectBox === 'TU_GIAI_QUYET')}>
              <div className="col-100 mt5">
                <h2 className="title-12 mb10">Tiến độ giải quyết</h2>
                <div className="row pl10 pr10">
                  <p className="attach-file-description mb10 pl5 pr5">Tiến độ giải quyết cho biết giai đoạn giải quyết hiện tại của đơn</p>
                  <ShowIf condition={!this.state.showTienDoGiaiQuyet && this.props.nhanDuThao != true}>
                    <DropDownKetQuaGiaiQuyetDon disable={this.state.ketQuaXLDGiaiQuyet != '' ? true : false} name="tienDoDoiThoai" className="col-25" selectedValue={this.state.tienDoDoiThoai} onChange={this.onChange.bind(this, 'tienDoDoiThoai')} isTTXMLai={this.props.isTTXMLai} loaiDon={this.props.loaiDon}/>
                    <ShowIf condition={this.state.tienDoDoiThoai == 'KHONG_DOI_THOAI'}>
                      <DropDownMulipleUse disable={this.state.ketQuaXLDGiaiQuyet != '' ? true : false} name="tienDoGiaiQuyet" confirm={true} label='' className="col-25" data={this.state.dataKetQuaGiaiQuyetDon} keyName='giaTri' valueName='ten' selectedValue={this.state.ketQuaXLDGiaiQuyet} onChange={this.onChange.bind(this, 'ketQuaXLDGiaiQuyet')}/>
                    </ShowIf>
                  </ShowIf>
                  <ShowIf condition={!this.state.showTienDoGiaiQuyet && this.props.nhanDuThao == true}>
                    <DropDownMulipleUse disable={this.state.ketQuaXLDGiaiQuyet != '' ? true : false}  name="tienDoGiaiQuyet" confirm={true} label='' className="col-25" data={this.state.dataKetQuaGiaiQuyetDon} keyName='giaTri' valueName='ten' selectedValue={this.state.ketQuaXLDGiaiQuyet} onChange={this.onChange.bind(this, 'ketQuaXLDGiaiQuyet')}/>
                  </ShowIf>
                  <ShowIf condition={this.state.showTienDoGiaiQuyet}>
                    <Text className="col-25 mb10" label='' value={ketQuaGiaiQuyetDon.length > 0 ? ketQuaGiaiQuyetDon[0].ten : ''}/>
                  </ShowIf>
                </div>
              </div>
              <ShowIf condition={this.state.tienDoDoiThoai == 'GIAO_THAM_TRA_XAC_MINH_LAI'}>
                <DatePicker require
                  className="col-25"
                  value={this.state.ngayHetHanGiaiQuyetTTXMLai}
                  label='Hạn giải quyết'
                  name="ngayHetHanGiaiQuyetTTXMLai"
                  startDate={moment(new Date()).subtract(1, "days")}
                  onChange={this.handleChangeDate.bind(this, 'ngayHetHanGiaiQuyetTTXMLai')}
                  bindValidator={this}
                  channel="formTaoDon" />
                <DatePicker require
                  className="col-25"
                  value={this.state.ngayRaThongBaoTTXM}
                  label={'Ngày ra văn bản '+lb1+' lại'}
                  name="ngayRaThongBaoTTXM"
                  onChange={this.handleChangeDate.bind(this, 'ngayRaThongBaoTTXM')}
                  bindValidator={this}
                  channel="formTaoDon" />
                <DatePicker require
                  className="col-25"
                  value={this.state.ngayHetHanTTXMLai}
                  label='Thời gian báo cáo kết quả'
                  name="ngayHetHanTTXMLai"
                  startDate={moment(new Date()).subtract(1, "days")}
                  onChange={this.handleChangeDate.bind(this, 'ngayHetHanTTXMLai')}
                  bindValidator={this}
                  channel="formTaoDon" />
                <TextArea
                  label="Ý kiến xử lý"
                  rows="3"
                  placeholder="Nhập ý kiến"
                  value={this.state.noiDungGiaoTTXMLai}
                  onChange={this.onChange.bind(this, 'noiDungGiaoTTXMLai')}
                  name="textareaYKienTTXM" />
              </ShowIf>
              <ShowIf condition={!this.state.showTienDoGiaiQuyet && this.props.nhanDuThao != true}>
                <ShowIf condition={this.state.tienDoDoiThoai == 'DOI_THOAI'}>
                  <div className="col-100">
                    <div className="col-100 no-gutter mt5 pb20">
                      <h2 className="title-12 mb15">Đối thoại</h2>
                      <div className="row pl10 pr10">
                        <DatePicker className="col-25" require bindValidator={this} channel="formTaoDon" label="Thời gian đối thoại" value={this.state.thoiGianDoiThoai} onChange={this.handleChangeDate.bind(this, 'thoiGianDoiThoai')} name="datepickerThoiGianDoiThoai"/>
                        <Input className="col-75" require bindValidator={this} channel="formTaoDon" label="Địa điểm" value={this.state.diaDiemDoiThoai} onChange={this.onChange.bind(this, 'diaDiemDoiThoai')} name="inputDiaDiem"/>
                        <TextArea className="col-100 mb0-18" channel="formTaoDon" label="Nội dung, kết quả đối thoại" name="ketQuaDoiThoai" value={this.state.noiDungDoiThoai} onChange={this.onChange.bind(this, 'noiDungDoiThoai')}/>
                      </div>
                    </div>
                  </div>
                  <div className="col-100 no-gutter pt5 pb15">
                    <span className="line-border"></span>
                  </div>
                </ShowIf>

                <ShowIf condition={this.state.tienDoDoiThoai == 'DOI_THOAI'}>
                  <div className="col-100">
                    <div className="col-100 no-gutter mt5 pb20">
                      <h2 className="title-12 mb15">Giao dự thảo quyết định giải quyết khiếu nại</h2>
                      <div className="row pl10 pr10">
                        <Text className="col-25 mb10" label="Thời gian trình dự thảo:" value={this.state.ngayHetHanGiaoLapDuThao ?  moment(this.state.ngayHetHanGiaoLapDuThao).format('DD/MM/YYYY') : ''} red/>
                        <TextArea className="col-100 mb0-18" label="Ý kiến xử lý" value={this.state.noiDungGiaoLapDuThao} onChange={this.onChange.bind(this, 'noiDungGiaoLapDuThao')} name='noiDungGiaoLapDuThao'/>
                      </div>
                    </div>
                  </div>
                </ShowIf>
              </ShowIf>
              <ShowIf condition={this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' || this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI'}>
                <div className="col-100">
                  <ShowIf condition={this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET'}>
                    <h3 className="txt-upper title-14 mt0 mb15">Quyết định giải quyết khiếu nại</h3>
                  </ShowIf>
                  <ShowIf condition={this.state.ketQuaXLDGiaiQuyet != 'DA_CO_QUYET_DINH_GIAI_QUYET'}>
                    <h3 className="txt-upper title-14 mt0 mb15">Quyết định đình chỉ</h3>
                  </ShowIf>

                  <div className="row pl10 pr10">
                    <Input triggeOnBlur={true} className="col-25" name="inputSoVanBan" label="Số văn bản" bindValidator={this} channel="formTaoDon" require value={this.state.soVanBan} onChange={this.onChange.bind(this, 'soVanBan')} maxLength={255}/>
                    <DatePicker className="col-25" label="Ngày ban hành" endDate={new Date()} bindValidator={this} channel="formTaoDon" require value={this.state.ngayBanHanh} onChange={this.handleChangeDate.bind(this, 'ngayBanHanh')} name="inputNgayBanHanh"/>
                    <DropDownNguoiKy selected={this.state.nguoiBanHanh} onChange={this.onChange.bind(this, 'nguoiBanHanh')} />
                    {
                      this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' ?
                        <TextArea value={this.state.lyDoBanHanhQuyetDinhGiaiQuyet} className="areal-wrap col-100" label={`Nội dung ${this.state.gqText}`} placeholder="Nhập ..." onChange={this.onChange.bind(this, 'lyDoBanHanhQuyetDinhGiaiQuyet')} name="lyDoBanHanhQuyetDinhGiaiQuyet"/>
                      : null
                    }
                    {
                      this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI' ?
                        <TextArea value={this.state.lyDoBanHanhQuyetDinhDinhChi} bindValidator={this} channel="formTaoDon" require className="areal-wrap col-100" label="Lý do đình chỉ" placeholder="Nhập lý do" onChange={this.onChange.bind(this, 'lyDoBanHanhQuyetDinhDinhChi')} name="lyDoBanHanhQuyetDinhDinhChi" maxLength={1000}/>
                      : null
                    }
                    <ShowIf condition={this.state.allowAttach}>
                      <div className="col-100 pt15">
                        <ContainerFileDinhKem loaiVanBanSuggest="QDGQ_LDT" name="QuyetDinhGiaiQuyet" quyetDinh={this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET' ? true : false} ngayQuyetDinhSuggest={this.state.ngayBanHanh} soVanBanSuggest={this.state.soVanBan} onSave={this.state.onSave} loaiDon={this.state.loaiDon} phanLoaiQuyTrinh='QUYET_DINH_GIAI_QUYET' qDGQText='QDGQ_LDT' qDGQRequired={true} label="Danh sách văn bản xử lý" bindValidator={this} data={this.props.listTaiLieuVanThuGiaiQuyetDonQuyetDinhGQ} onFileRemove={this.onFileRemove.bind(this)} onFileChange={this.onFileChange.bind(this)}/>
                      </div>
                    </ShowIf>
                  </div>

                  <div className="col-100 no-gutter pt10 pb20">
                    <span className="line-border"></span>
                  </div>
                  <ShowIf condition={this.state.ketQuaXLDGiaiQuyet == 'DA_CO_QUYET_DINH_GIAI_QUYET'}>
                    { this.props.donInfo.layVuViecCu === true &&
                      <div className="row pl10 pr10">
                        <DropDownChonKetQuaGiaiQuyet className='col-25' name="ketQuaGiaiQuyetLan2" require bindValidator={this} label='Kết quả giải quyết' selectedValue={this.state.ketQuaGiaiQuyetLan2} onChange={this.onChange.bind(this, 'ketQuaGiaiQuyetLan2')}/>

                        { this.state.ketQuaGiaiQuyetLan2 === 'HUY_SUA_QDGQ_LAN_I' &&
                          <TextArea className='col-100' label='Lý do' require bindValidator={this} channel='formTaoDon' value={this.state.noiDungKetLuanGiaiQuyetLai} onChange={this.onChange.bind(this, 'noiDungKetLuanGiaiQuyetLai')} name="noiDungKetLuanGiaiQuyetLai" maxLength={1000}/>
                        }
                      </div>
                    }
                    <div className="row pl10 pr10">
                      <InputNumber className="col-25 mb0-18" label="Số vụ" value={Number(this.state.soVuGiaiQuyetKhieuNai)} onChange={this.onChange.bind(this, 'soVuGiaiQuyetKhieuNai')} name="soVuDonToCao"/>
                      <DropDownChonKetLuanNoiDungKhieuNai require bindValidator={this} channel="formTaoDon" loaiDon={this.props.loaiDon} name="DropDownChonKetLuanNoiDungKhieuNai" label={this.props.loaiDon === "DON_TRANH_CHAP_DAT" ? "Kết luận nội dung tranh chấp đất" : "Kết luận nội dung khiếu nại"} className="col-25" selectedValue={this.state.ketLuanNoiDungKhieuNai} onChange={this.onChange.bind(this, 'ketLuanNoiDungKhieuNai')}/>
                      <Input className="col-25 mb0-18" label="Kết quả khác" name="ketQuaKhac" value={this.state.ketQuaGiaiQuyetKhac} onChange={this.onChange.bind(this, 'ketQuaGiaiQuyetKhac')}/>
                    </div>
                    <div className="row pl10 pr10 mb5">
                      <div className="col-50 no-gutter mb20">
                        <p className="txt-bold txt-upper mb10 pl5 pr5">Thu hồi cho nhà nước</p>
                        <Input className="col-50 mb0-18" type="sdt" align="right" label="Phải thu tiền (đ)" value={this.state.tienPhaiThuNhaNuocQDGQ} onChange={this.onChange.bind(this, 'tienPhaiThuNhaNuocQDGQ')} name="tienPhaiThuDonToCao"/>
                        <Input className="col-50 mb0-18" type="sdt" align="right" label="Phải thu đất (m2)" value={this.state.datPhaiThuNhaNuocQDGQ} onChange={this.onChange.bind(this, 'datPhaiThuNhaNuocQDGQ')} name="datPhaiThuDonToCao"/>
                      </div>
                      <div className="col-50 no-gutter mb20">
                        <p className="txt-bold txt-upper mb10 pl5 pr5">Trả lại cho công dân</p>
                        <Input className="col-50 mb0-18" type="sdt" align="right" label="Phải trả tiền (đ)" value={this.state.tienPhaiTraCongDanQDGQ} onChange={this.onChange.bind(this, 'tienPhaiTraCongDanQDGQ')} name="tienPhaiTraDonToCao"/>
                        <Input className="col-50 mb0-18" type="sdt" align="right" label="Phải trả đất (m2)" value={this.state.datPhaiTraCongDanQDGQ} onChange={this.onChange.bind(this, 'datPhaiTraCongDanQDGQ')} name="datPhaiTraDonToCao"/>
                      </div>
                      <div className="col-100 no-gutter">
                        <p className="txt-bold txt-upper mb10 pl5 pr5">Xử lý hành chính</p>
                        <InputNumber className="col-25 mb0-18" label="Tổng số người" value={Number(this.state.tongSoNguoiXuLyHanhChinh)} onChange={this.onChange.bind(this, 'tongSoNguoiXuLyHanhChinh')} name="tongSoNguoiXuLyDonToCao"/>
                        <InputNumber className="col-25 mb0-18" label="Số người đã bị xử lý" value={Number(this.state.soNguoiDaBiXuLyHanhChinh)} onChange={this.onChange.bind(this, 'soNguoiDaBiXuLyHanhChinh')} name="soNguoiDaBiXuLyDonToCao"/>
                        <InputNumber className="col-25 mb0-18" label="Số người được trả lại quyền lợi" value={this.state.soNguoiDuocTraLaiQuyenLoi} onChange={this.onChange.bind(this, 'soNguoiDuocTraLaiQuyenLoi')} name="inputnumberSoNguoiTraQuyenLoi"/>
                      </div>
                    </div>
                    <div className="col-100 pt10 pb15">
                      <span className="line-border"></span>
                    </div>

                  </ShowIf>


                  <div className="col-100">
                    <ShowIfCheck label="Chuyển cơ quan điều tra" onChange={this.handleCheck.bind(this, 'giaoCoQuanDieuTra')} checked={this.state.giaoCoQuanDieuTra}>
                      <div className="col-100 no-gutter mt5 pb5">
                        <h2 className="title-12 mb15">Chuyển cơ quan điều tra</h2>
                        <div className="row pl10 pr10">
                          <DropDownChonCoQuanDieuTra name="DropDownChonCoQuanDieuTra" className="col-25 mb0-18" label="Tên cơ quan" isValid={this.state.isValid} bindValidator={this} require selectedValue={this.state.coQuanDieuTra} onChange={this.onChange.bind(this, 'coQuanDieuTra')}/>
                          <InputNumber className="col-25 mb0-18" name="soVuGiaoCoQuanDieuTra" label="Số vụ" value={Number(this.state.soVuGiaoCoQuanDieuTra)} onChange={this.onChange.bind(this, 'soVuGiaoCoQuanDieuTra')}/>
                          <InputNumber className="col-25 mb0-18" name="soDoiTuongGiaoCoQuanDieuTra" label="Số đối tượng" value={Number(this.state.soDoiTuongGiaoCoQuanDieuTra)} onChange={this.onChange.bind(this, 'soDoiTuongGiaoCoQuanDieuTra')} maxLength={255}/>
                          <ShowIf condition={this.state.allowAttachGiaoCoQuanDieuTra}>
                            <div className="col-100 pt15">
                              <ContainerFileDinhKem name="GiaoCQDT" onSave={this.state.onSave} phanLoaiQuyTrinh='GIAO_CO_QUAN_DIEU_TRA' label="Danh sách văn bản xử lý" bindValidator={this} data={this.state.taiLieuVanThuGiaoCoQuanDieuTra} onFileRemove={this.onFileRemove.bind(this)} onFileChange={this.onFileChange.bind(this)}/>
                            </div>
                          </ShowIf>
                        </div>
                      </div>
                      <div className="col-100 pt5 pb15">
                        <span className="line-border"></span>
                      </div>

                      <div className="col-100">
                        <ShowIfCheck label="Khởi tố" onChange={this.handleCheck.bind(this, 'khoiTo')} checked={this.state.khoiTo}>
                          <div className="col-100 no-gutter mt5 pb20">
                            <h2 className="title-12 mb15">Khởi tố</h2>
                            <div className="row pl10 pr10">
                              <div className="col-50 no-gutter">
                                <InputNumber className="col-50 mb0-18" name="soVuBiKhoiTo" label="Số vụ" value={this.state.soVuBiKhoiTo} onChange={this.onChange.bind(this, 'soVuBiKhoiTo')}/>
                                <InputNumber className="col-50 mb0-18" name="soDoiTuongBiKhoiTo" label="Số đối tượng" value={this.state.soDoiTuongBiKhoiTo} onChange={this.onChange.bind(this, 'soDoiTuongBiKhoiTo')} maxLength={255}/>
                              </div>
                            </div>
                          </div>
                        </ShowIfCheck>
                      </div>
                    </ShowIfCheck>
                  </div>
                </div>
              </ShowIf>
            </ShowIf>

            <ShowIf condition={this.state.allowAttach}>
              <div className="col-100 pb5">
                <ContainerFileDinhKem name="TaiLieuVTGQD"
                  onSave={this.state.onSave} label="Danh sách văn bản xử lý" bindValidator={this}
                  dataShow={this.state.listTaiLieuVanThuGiaiQuyetDonView}
                  data={this.state.listTaiLieuVanThuGiaiQuyetDon}
                  loaiVanBanSuggest={this.state.loaiVanBanSuggest}
                  ngayQuyetDinhSuggest={this.state.ngayQuyetDinhSuggest}
                  onFileRemove={this.onFileRemove.bind(this)}
                  onFileChange={this.onFileChange.bind(this)}/>
              </div>
            </ShowIf>
            <div className="box-bottom col-100 gqd-wrap">
              <div className="wrap-big-line mt10 mb20"><div className="line-border"></div></div>
              <Link className="btn-action btn-close action-todo" role="button" onClick={this.onClickClose.bind(this)}><span>Đóng</span></Link>
              <span className="wrap-link">
                <Link className={this.state.btnLoading ? (this.state.btnSaveLoading ? "btn-action btn-save action-todo btn-loading-inline" : 'btn-action btn-save action-todo btn-disable') : "btn-action btn-save action-todo"} onClick={this.handleSave.bind(this, 'truongPhongGiaiQuyetDon')}><span>Lưu tạm</span></Link>
                <ShowIf condition={this.state.nextState == 'TRUONG_PHONG_GIAO_VIEC_CAN_BO_SAU_KHI_NHAN_KET_QUA_TTXM' || this.state.nextState == 'TRUONG_PHONG_GIAO_VIEC_CAN_BO_SAU_KHI_NHAN_DU_THAO' || this.state.nextState === 'TRUONG_PHONG_GIAO_VIEC_PHO_PHONG' }>
                  <Link className={this.state.btnLoading ? (this.state.btnSaveLoading ? "btn-action btn-complete action-todo btn-disable" : 'btn-action btn-complete action-todo btn-loading-inline') : "btn-action btn-complete action-todo"} onClick={this.handleGiaiQuyetDon.bind(this, 'giaoCanBo')}><span>Giao việc</span></Link>
                </ShowIf>
                <ShowIf condition={this.state.nextState === 'TRUONG_PHONG_NHAN_KET_QUA_TTXM' || this.state.nextState === 'KET_THUC' || this.state.nextState === 'NHANKQDUTHAO_GIAO_PHONG_CUNG_CAP'}>
                  <ShowIf condition={this.state.typeButton === 'PHONG_NOI_CHINH' && checkThamSo() !== 'CQQL_BAN_TIEP_CONG_DAN' && this.state.valueSelectBox !== 'CHUYEN_PHONG_BAN_KHAC'}>
                    <Link className={classNames('btn-action btn-complete action-todo', { 'btn-disable' : this.state.btnSaveLoading, 'btn-loading-inline' : !this.state.btnSaveLoading })} onClick={this.openDialog.bind(this, 'openDialogNoiChinh')}><span>Chuyển cho phòng nội chính</span></Link>
                  </ShowIf>
                  <ShowIf condition={this.state.typeButton === 'PHONG_NOI_CHINH' && checkThamSo() === 'CQQL_BAN_TIEP_CONG_DAN' && this.state.valueSelectBox === 'CHUYEN_PHONG_BAN_KHAC'}>
                    <Link className={this.state.btnLoading ? (this.state.btnSaveLoading ? "btn-action btn-complete action-todo btn-disable" : 'btn-action btn-complete action-todo btn-loading-inline') : "btn-action btn-complete action-todo"} onClick={this.openDialog.bind(this, 'openDialogNoiChinh')}><span>Chuyển cho phòng nội chính</span></Link>
                  </ShowIf>
                  <ShowIf condition={this.state.typeButton == 'VAN_PHONG_UBND'}>
                    <Link className={this.state.btnLoading ? (this.state.btnSaveLoading ? "btn-action btn-complete action-todo btn-disable" : 'btn-action btn-complete action-todo btn-loading-inline') : "btn-action btn-complete action-todo"} onClick={this.openDialog.bind(this, 'openDialogVanPhong')}><span>Chuyển cho VP UBND Tỉnh</span></Link>
                  </ShowIf>
                  <ShowIf condition={this.state.typeButton != 'PHONG_NOI_CHINH' && this.state.typeButton != 'VAN_PHONG_UBND' && this.state.nextState !== "KET_THUC"}>
                    <Link className={this.state.btnLoading ? (this.state.btnSaveLoading ? "btn-action btn-complete action-todo btn-disable" : 'btn-action btn-complete action-todo btn-loading-inline') : "btn-action btn-complete action-todo"} onClick={this.handleGiaiQuyetDon.bind(this, 'giaoPhongBan')}><span>Giao việc</span></Link>
                  </ShowIf>
                </ShowIf>
                <ShowIf condition={(this.state.ketQuaXLDGiaiQuyet === 'DA_CO_QUYET_DINH_GIAI_QUYET' || this.state.ketQuaXLDGiaiQuyet === 'DA_CO_QUYET_DINH_GIAI_QUYET_DINH_CHI') && this.state.valueSelectBox !== 'CHUYEN_PHONG_BAN_KHAC'}>
                  <Link className={this.state.btnLoading ? (this.state.btnSaveLoading ? "btn-action btn-complete action-todo btn-disable" : 'btn-action btn-complete action-todo btn-loading-inline') : "btn-action btn-complete action-todo"} onClick={this.openDialog.bind(this, 'openDialogLuuHoSo')}><span>Chuyển theo dõi thực hiện</span></Link>
                </ShowIf>
                <ShowIf condition={this.state.tienDoDoiThoai === 'DOI_THOAI' && this.state.nextState === 'KET_THUC' && this.state.valueSelectBox !== 'CHUYEN_PHONG_BAN_KHAC' && this.props.roleGQ === "truongPhongBanTiepCongDan"}>
                  <Link className={this.state.btnLoading ? (this.state.btnSaveLoading ? "btn-action btn-complete action-todo btn-disable" : 'btn-action btn-complete action-todo btn-loading-inline') : "btn-action btn-complete action-todo"} onClick={this.openDialog.bind(this, 'openDialogGiaoDoiThoai')}><span>Chuyển đơn vị {lb1}</span></Link>
                </ShowIf>
                <ShowIf condition={this.state.nextState === 'KET_THUC' && this.state.tienDoDoiThoai === 'GIAO_THAM_TRA_XAC_MINH_LAI'}>
                  <Link className={this.state.btnLoading ? (this.state.btnSaveLoading ? "btn-action btn-complete action-todo btn-disable" : 'btn-action btn-complete action-todo btn-loading-inline') : "btn-action btn-complete action-todo"} onClick={this.openDialog.bind(this, 'openDialogGiaoTTXML')}><span>Giao {lb1} lại</span></Link>
                </ShowIf>
              </span>
              <ConfirmDialog open={this.state.openDialogLuuHoSo} onClose={this.closeDialog.bind(this, 'openDialogLuuHoSo')} onSuccess={this.onSuccess.bind(this, 'openDialogLuuHoSo')} title="Xác nhận" content={`Bạn có đồng ý chuyển đơn/vụ việc này cho ${this.state.tenDonViTheoDoiThucHien} theo dõi thực hiện không?`}/>
              <ConfirmDialog open={this.state.openDialogGiaoDoiThoai} onClose={this.closeDialog.bind(this, 'openDialogGiaoDoiThoai')} onSuccess={this.onSuccess.bind(this, 'openDialogGiaoDoiThoai')} title="Xác nhận" content={'Bạn có đồng ý chuyển đơn/vụ việc này cho ' + (this.state.dataGiaiQuyetDon && this.state.dataGiaiQuyetDon.donViThamTraXacMinhInfo ? this.state.dataGiaiQuyetDon.donViThamTraXacMinhInfo.ten : '' ) + ' lập dự thảo không ?'}/>
              <ConfirmDialog open={this.state.openDialogNoiChinh} onClose={this.closeDialog.bind(this,'openDialogNoiChinh')} onSuccess={this.onSuccess.bind(this, 'openDialogNoiChinh')} title="Xác nhận" content="Bạn có đồng ý chuyển đơn/vụ việc này cho phòng Nội chính không?"/>
              <ConfirmDialog open={this.state.openDialogVanPhong} onClose={this.closeDialog.bind(this,'openDialogVanPhong')} onSuccess={this.onSuccess.bind(this, 'openDialogVanPhong')} title="Xác nhận" content="Bạn có đồng ý chuyển đơn/vụ việc này cho VP UBND Tỉnh không?"/>
              <ConfirmDialog open={this.state.openDialogGiaoTTXML} onClose={this.closeDialog.bind(this,'openDialogGiaoTTXML')} onSuccess={this.onSuccess.bind(this, 'openDialogGiaoTTXML')} title="Xác nhận" content={`Bạn có đồng ý chuyển đơn/vụ việc này cho ${this.state.dataGiaiQuyetDon.donViThamTraXacMinhInfo ? this.state.dataGiaiQuyetDon.donViThamTraXacMinhInfo.ten : ''} ${lb2} lại không?`}/>
            </div>
          </div>
          <Dialog
            isOpen={this.state.open}
            onClose={this.closeDialogConfirm.bind(this)}
            title='Xác nhận'
            className="reception-dialog delete-dialog wrap-block"
            >
              <div className="pt-dialog-body">
                <p className="reception-dialog-text">{this.state.message}</p>
              </div>
              <div className="box-bottom col-100">
                <Link className="btn-action btn-close action-todo" onClick={this.closeDialogConfirm.bind(this)}><span>Không</span></Link>
                <Link className="btn-green" onClick={this.onSuccessDialogConfirm.bind(this)}><span>Đồng ý</span></Link>
              </div>
            </Dialog>
        </form>
      </section>
    );
  }
}

TruongPhongNhanBaoCaoTTXMDonKhieuNai.defaultProps = {
  isTTXMLai: false,
  dataKetLuanNoiDungKhieuNai: [],
  ketQuaGiaiQuyetDon: [],
  validators: {
    formTaoDon: []
  }
}

let bindStateToProps = state => {
  return {
    dataKetLuanNoiDungKhieuNai: state.duLieuHeThong.ketLuanNoiDungKhieuNai,
    ketQuaGiaiQuyetDon: state.duLieuHeThong.ketQuaGiaiQuyetDon
  }
}

export default connect(bindStateToProps)(TruongPhongNhanBaoCaoTTXMDonKhieuNai);



// WEBPACK FOOTER //
// ./src/components/modules/giai-quyet-don/subView/TruongPhongNhanBaoCaoTTXMDonKhieuNai.jsx